var pricing = [
    {
        "name": "ECS-20vCPU-40GB-WIN-1Yr-UpFront",
        "price": 1743.14,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204012FU"
    },
    {
        "name": "ECS-18vCPU-144GB-RedHat-3Yrs-UpFront",
        "price": 1707.51,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0114436FU"
    },
    {
        "name": "ECS-6vCPU-24GB-RedHat-1Yr-UpFront",
        "price": 839.69,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0102412FU"
    },
    {
        "name": "ECS-22vCPU-44GB-Linux-3Yrs-PartUpFront",
        "price": 1074.13,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204436PU"
    },
    {
        "name": "ECS-12vCPU-96GB-WIN-3Yrs-NoUpFront",
        "price": 2418.95,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0109636MO"
    },
    {
        "name": "ECS-10vCPU-80GB-WIN-3Yrs-UpFront",
        "price": 1939,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0108036FU"
    },
    {
        "name": "ECS-1vCPU-2GB-Linux-1Yr-UpFront",
        "price": 70.08,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200212FU"
    },
    {
        "name": "ECS-18vCPU-36GB-WIN-1Yr-NoUpFront",
        "price": 1671.7,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203612MO"
    },
    {
        "name": "ECS-8vCPU-64GB-WIN-1Yr-UpFront",
        "price": 1674.07,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0106412FU"
    },
    {
        "name": "ECS-18vCPU-144GB-WIN-1Yr-NoUpFront",
        "price": 3973.99,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0114412MO"
    },
    {
        "name": "ECS-10vCPU-80GB-WIN-3Yrs-PartUpFront",
        "price": 1977.39,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0108036PU"
    },
    {
        "name": "ECS-26vCPU-52GB-RedHat-3Yrs-NoUpFront",
        "price": 1878.12,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205236MO"
    },
    {
        "name": "ECS-12vCPU-96GB-RedHat-1Yr-NoUpFront",
        "price": 1654.19,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0109612MO"
    },
    {
        "name": "ECS-14vCPU-28GB-RedHat-1Yr-UpFront",
        "price": 1283.64,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202812FU"
    },
    {
        "name": "ECS-8vCPU-16GB-RedHat-On-Demand",
        "price": 1.87,
        "vcpu": "8",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201600MO"
    },
    {
        "name": "ECS-24vCPU-48GB-Linux-1Yr-PartUpFront",
        "price": 1709.41,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204812PU"
    },
    {
        "name": "ECS-18vCPU-144GB-Linux-1Yr-NoUpFront",
        "price": 2153.92,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0114412MO"
    },
    {
        "name": "ECS-28vCPU-56GB-WIN-1Yr-PartUpFront",
        "price": 2480.4,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205612PU"
    },
    {
        "name": "ECS-8vCPU-32GB-Linux-1Yr-PartUpFront",
        "price": 769.3,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0103212PU"
    },
    {
        "name": "ECS-16vCPU-128GB-RedHat-3Yrs-NoUpFront",
        "price": 1526.92,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0112836MO"
    },
    {
        "name": "ECS-10vCPU-40GB-WIN-1Yr-PartUpFront",
        "price": 1417.57,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104012PU"
    },
    {
        "name": "ECS-16vCPU-128GB-Linux-1Yr-NoUpFront",
        "price": 1914.6,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0112812MO"
    },
    {
        "name": "ECS-32vCPU-128GB-WIN-3Yrs-UpFront",
        "price": 3393.25,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112836FU"
    },
    {
        "name": "ECS-1vCPU-8GB-WIN-1Yr-PartUpFront",
        "price": 215.02,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0100812PU"
    },
    {
        "name": "ECS-28vCPU-56GB-RedHat-3Yrs-PartUpFront",
        "price": 1832.87,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205636PU"
    },
    {
        "name": "ECS-14vCPU-56GB-Linux-1Yr-NoUpFront",
        "price": 1416.52,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0105612MO"
    },
    {
        "name": "ECS-14vCPU-112GB-Linux-3Yrs-UpFront",
        "price": 1085.12,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0111236FU"
    },
    {
        "name": "ECS-18vCPU-144GB-WIN-1Yr-UpFront",
        "price": 3766.65,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0114412FU"
    },
    {
        "name": "ECS-2vCPU-8GB-Linux-3Yrs-NoUpFront",
        "price": 142.15,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100836MO"
    },
    {
        "name": "ECS-24vCPU-48GB-RedHat-1Yr-NoUpFront",
        "price": 2504.53,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204812MO"
    },
    {
        "name": "ECS-26vCPU-104GB-RedHat-On-Demand",
        "price": 6.5,
        "vcpu": "26",
        "ram": "104",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0110400MO"
    },
    {
        "name": "ECS-32vCPU-64GB-WIN-3Yrs-PartUpFront",
        "price": 2057.47,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206436PU"
    },
    {
        "name": "ECS-18vCPU-36GB-WIN-3Yrs-PartUpFront",
        "price": 1157.33,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203636PU"
    },
    {
        "name": "ECS-32vCPU-64GB-WIN-1Yr-UpFront",
        "price": 2789.02,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206412FU"
    },
    {
        "name": "ECS-1vCPU-4GB-WIN-1Yr-UpFront",
        "price": 138.41,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100412FU"
    },
    {
        "name": "ECS-1vCPU-8GB-RedHat-3Yrs-PartUpFront",
        "price": 222.71,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0100836PU"
    },
    {
        "name": "ECS-18vCPU-36GB-Linux-3Yrs-NoUpFront",
        "price": 951.21,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203636MO"
    },
    {
        "name": "ECS-20vCPU-80GB-WIN-3Yrs-PartUpFront",
        "price": 2165.43,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108036PU"
    },
    {
        "name": "ECS-18vCPU-72GB-WIN-3Yrs-PartUpFront",
        "price": 1948.89,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0107236PU"
    },
    {
        "name": "ECS-1vCPU-2GB-WIN-1Yr-UpFront",
        "price": 87.16,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200212FU"
    },
    {
        "name": "ECS-1vCPU-4GB-RedHat-3Yrs-NoUpFront",
        "price": 281.88,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100436MO"
    },
    {
        "name": "ECS-4vCPU-32GB-WIN-3Yrs-PartUpFront",
        "price": 790.96,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0103236PU"
    },
    {
        "name": "ECS-30vCPU-60GB-RedHat-3Yrs-NoUpFront",
        "price": 2089.5,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206036MO"
    },
    {
        "name": "ECS-14vCPU-56GB-RedHat-3Yrs-UpFront",
        "price": 1049.82,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0105636FU"
    },
    {
        "name": "ECS-4vCPU-8GB-WIN-3Yrs-UpFront",
        "price": 251.47,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200836FU"
    },
    {
        "name": "ECS-2vCPU-4GB-Linux-3Yrs-UpFront",
        "price": 90.76,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200436FU"
    },
    {
        "name": "ECS-32vCPU-64GB-Linux-3Yrs-NoUpFront",
        "price": 1691.03,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206436MO"
    },
    {
        "name": "ECS-2vCPU-8GB-RedHat-1Yr-NoUpFront",
        "price": 502.44,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100812MO"
    },
    {
        "name": "ECS-28vCPU-112GB-RedHat-1Yr-NoUpFront",
        "price": 3496.13,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0111212MO"
    },
    {
        "name": "ECS-20vCPU-80GB-Linux-1Yr-PartUpFront",
        "price": 1923.26,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108012PU"
    },
    {
        "name": "ECS-18vCPU-36GB-Linux-1Yr-UpFront",
        "price": 1261.38,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203612FU"
    },
    {
        "name": "ECS-10vCPU-20GB-WIN-3Yrs-NoUpFront",
        "price": 657.25,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202036MO"
    },
    {
        "name": "ECS-16vCPU-128GB-RedHat-3Yrs-UpFront",
        "price": 1381.5,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0112836FU"
    },
    {
        "name": "ECS-18vCPU-144GB-WIN-3Yrs-UpFront",
        "price": 3490.2,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0114436FU"
    },
    {
        "name": "ECS-8vCPU-32GB-WIN-1Yr-NoUpFront",
        "price": 1160.85,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0103212MO"
    },
    {
        "name": "ECS-18vCPU-72GB-Linux-1Yr-PartUpFront",
        "price": 1730.93,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0107212PU"
    },
    {
        "name": "ECS-24vCPU-96GB-Linux-3Yrs-UpFront",
        "price": 1485.09,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0109636FU"
    },
    {
        "name": "ECS-28vCPU-56GB-RedHat-1Yr-PartUpFront",
        "price": 2673.84,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205612PU"
    },
    {
        "name": "ECS-8vCPU-16GB-RedHat-1Yr-UpFront",
        "price": 863.17,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201612FU"
    },
    {
        "name": "ECS-1vCPU-2GB-WIN-1Yr-NoUpFront",
        "price": 92.87,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200212MO"
    },
    {
        "name": "ECS-14vCPU-28GB-WIN-3Yrs-PartUpFront",
        "price": 900.14,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202836PU"
    },
    {
        "name": "ECS-8vCPU-16GB-WIN-On-Demand",
        "price": 1.51,
        "vcpu": "8",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201600MO"
    },
    {
        "name": "ECS-8vCPU-64GB-WIN-On-Demand",
        "price": 2.99,
        "vcpu": "8",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0106400MO"
    },
    {
        "name": "ECS-2vCPU-8GB-Linux-3Yrs-UpFront",
        "price": 123.76,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100836FU"
    },
    {
        "name": "ECS-22vCPU-44GB-WIN-3Yrs-NoUpFront",
        "price": 1445.95,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204436MO"
    },
    {
        "name": "ECS-18vCPU-144GB-Linux-1Yr-PartUpFront",
        "price": 2031.54,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0114412PU"
    },
    {
        "name": "ECS-20vCPU-80GB-Linux-3Yrs-NoUpFront",
        "price": 1421.54,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108036MO"
    },
    {
        "name": "ECS-32vCPU-64GB-RedHat-1Yr-PartUpFront",
        "price": 2958.74,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206412PU"
    },
    {
        "name": "ECS-18vCPU-72GB-Linux-3Yrs-NoUpFront",
        "price": 1279.39,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0107236MO"
    },
    {
        "name": "ECS-18vCPU-36GB-WIN-3Yrs-UpFront",
        "price": 1131.61,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203636FU"
    },
    {
        "name": "ECS-28vCPU-56GB-WIN-On-Demand",
        "price": 5.28,
        "vcpu": "28",
        "ram": "56",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205600MO"
    },
    {
        "name": "ECS-20vCPU-40GB-Linux-3Yrs-UpFront",
        "price": 907.55,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204036FU"
    },
    {
        "name": "ECS-12vCPU-96GB-RedHat-3Yrs-PartUpFront",
        "price": 1090.26,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0109636PU"
    },
    {
        "name": "ECS-10vCPU-80GB-RedHat-1Yr-NoUpFront",
        "price": 1414.86,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0108012MO"
    },
    {
        "name": "ECS-10vCPU-20GB-RedHat-On-Demand",
        "price": 2.17,
        "vcpu": "10",
        "ram": "20",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202000MO"
    },
    {
        "name": "ECS-18vCPU-36GB-Linux-3Yrs-UpFront",
        "price": 816.8,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203636FU"
    },
    {
        "name": "ECS-30vCPU-120GB-WIN-1Yr-NoUpFront",
        "price": 4353.18,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112012MO"
    },
    {
        "name": "ECS-16vCPU-32GB-RedHat-3Yrs-NoUpFront",
        "price": 1073.68,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203236MO"
    },
    {
        "name": "ECS-28vCPU-112GB-WIN-3Yrs-PartUpFront",
        "price": 3031.6,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0111236PU"
    },
    {
        "name": "ECS-4vCPU-8GB-Linux-1Yr-NoUpFront",
        "price": 298.69,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200812MO"
    },
    {
        "name": "ECS-18vCPU-72GB-RedHat-1Yr-UpFront",
        "price": 2299.54,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0107212FU"
    },
    {
        "name": "ECS-6vCPU-12GB-RedHat-1Yr-UpFront",
        "price": 723.02,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201212FU"
    },
    {
        "name": "ECS-32vCPU-64GB-RedHat-1Yr-NoUpFront",
        "price": 3101.9,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206412MO"
    },
    {
        "name": "ECS-12vCPU-96GB-WIN-3Yrs-UpFront",
        "price": 2326.8,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0109636FU"
    },
    {
        "name": "ECS-4vCPU-16GB-Linux-1Yr-NoUpFront",
        "price": 404.72,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0101612MO"
    },
    {
        "name": "ECS-2vCPU-16GB-Linux-3Yrs-UpFront",
        "price": 155.02,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0101636FU"
    },
    {
        "name": "ECS-14vCPU-56GB-Linux-On-Demand",
        "price": 2.8,
        "vcpu": "14",
        "ram": "56",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0105600MO"
    },
    {
        "name": "ECS-30vCPU-60GB-Linux-On-Demand",
        "price": 4.55,
        "vcpu": "30",
        "ram": "60",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206000MO"
    },
    {
        "name": "ECS-20vCPU-40GB-RedHat-On-Demand",
        "price": 4.48,
        "vcpu": "20",
        "ram": "40",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204000MO"
    },
    {
        "name": "ECS-2vCPU-4GB-WIN-1Yr-NoUpFront",
        "price": 185.74,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200412MO"
    },
    {
        "name": "ECS-8vCPU-16GB-Linux-On-Demand",
        "price": 1.21,
        "vcpu": "8",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201600MO"
    },
    {
        "name": "ECS-28vCPU-112GB-WIN-3YrsNoUpFront",
        "price": 3125.36,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0111236MO"
    },
    {
        "name": "ECS-14vCPU-56GB-Linux-3Yrs-PartUpFront",
        "price": 924.84,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0105636PU"
    },
    {
        "name": "ECS-1vCPU-4GB-RedHat-On-Demand",
        "price": 0.79,
        "vcpu": "1",
        "ram": "4",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100400MO"
    },
    {
        "name": "ECS-22vCPU-44GB-RedHat-3Yrs-PartUpFront",
        "price": 1539.93,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204436PU"
    },
    {
        "name": "ECS-20vCPU-80GB-WIN-3YrsNoUpFront",
        "price": 2232.4,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108036MO"
    },
    {
        "name": "ECS-6vCPU-48GB-Linux-3Yrs-NoUpFront",
        "price": 514,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0104836MO"
    },
    {
        "name": "ECS-6vCPU-48GB-RedHat-1Yr-NoUpFront",
        "price": 936.21,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0104812MO"
    },
    {
        "name": "ECS-16vCPU-32GB-Linux-3Yrs-PartUpFront",
        "price": 781.18,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203236PU"
    },
    {
        "name": "ECS-12vCPU-48GB-RedHat-1Yr-UpFront",
        "price": 1401.61,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104812FU"
    },
    {
        "name": "ECS-12vCPU-96GB-Linux-On-Demand",
        "price": 3.17,
        "vcpu": "12",
        "ram": "96",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0109600MO"
    },
    {
        "name": "ECS-6vCPU-48GB-Linux-3Yrs-PartUpFront",
        "price": 473.21,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0104836PU"
    },
    {
        "name": "ECS-12vCPU-96GB-Linux-1Yr-PartUpFront",
        "price": 1354.36,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0109612PU"
    },
    {
        "name": "ECS-20vCPU-80GB-RedHat-3Yrs-PartUpFront",
        "price": 1754.12,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108036PU"
    },
    {
        "name": "ECS-28vCPU-112GB-Linux-3Yrs-NoUpFront",
        "price": 1990.16,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0111236MO"
    },
    {
        "name": "ECS-10vCPU-80GB-Linux-3Yrs-NoUpFront",
        "price": 856.67,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0108036MO"
    },
    {
        "name": "ECS-18vCPU-72GB-WIN-1Yr-UpFront",
        "price": 2491.36,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0107212FU"
    },
    {
        "name": "ECS-30vCPU-120GB-RedHat-3Yrs-PartUpFront",
        "price": 2414.71,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112036PU"
    },
    {
        "name": "ECS-14vCPU-56GB-WIN-1Yr-PartUpFront",
        "price": 1984.6,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0105612PU"
    },
    {
        "name": "ECS-14vCPU-56GB-WIN-3YrsNoUpFront",
        "price": 1562.68,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0105636MO"
    },
    {
        "name": "ECS-10vCPU-40GB-RedHat-3Yrs-NoUpFront",
        "price": 921.57,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104036MO"
    },
    {
        "name": "ECS-18vCPU-72GB-WIN-3Yrs-UpFront",
        "price": 1908.7,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0107236FU"
    },
    {
        "name": "ECS-28vCPU-56GB-WIN-3Yrs-UpFront",
        "price": 1760.28,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205636FU"
    },
    {
        "name": "ECS-24vCPU-96GB-WIN-1Yr-UpFront",
        "price": 3321.81,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0109612FU"
    },
    {
        "name": "ECS-16vCPU-64GB-Linux-3Yrs-PartUpFront",
        "price": 1056.96,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0106436PU"
    },
    {
        "name": "ECS-8vCPU-16GB-Linux-1Yr-PartUpFront",
        "price": 569.8,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201612PU"
    },
    {
        "name": "ECS-26vCPU-52GB-RedHat-1Yr-PartUpFront",
        "price": 2531.39,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205212PU"
    },
    {
        "name": "ECS-10vCPU-80GB-WIN-On-Demand",
        "price": 3.73,
        "vcpu": "10",
        "ram": "80",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0108000MO"
    },
    {
        "name": "ECS-4vCPU-8GB-RedHat-3Yrs-UpFront",
        "price": 377.43,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200836FU"
    },
    {
        "name": "ECS-24vCPU-48GB-Linux-1Yr-UpFront",
        "price": 1681.84,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204812FU"
    },
    {
        "name": "ECS-4vCPU-16GB-RedHat-3Yrs-UpFront",
        "price": 431.04,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0101636FU"
    },
    {
        "name": "ECS-8vCPU-32GB-WIN-3Yrs-UpFront",
        "price": 848.31,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0103236FU"
    },
    {
        "name": "ECS-22vCPU-88GB-RedHat-1Yr-UpFront",
        "price": 2674.16,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108812FU"
    },
    {
        "name": "ECS-12vCPU-48GB-Linux-1Yr-UpFront",
        "price": 1123.85,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104812FU"
    },
    {
        "name": "ECS-8vCPU-16GB-WIN-3Yrs-PartUpFront",
        "price": 514.37,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201636PU"
    },
    {
        "name": "ECS-14vCPU-56GB-Linux-3Yrs-UpFront",
        "price": 866.3,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0105636FU"
    },
    {
        "name": "ECS-28vCPU-112GB-Linux-1Yr-PartUpFront",
        "price": 2692.56,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0111212PU"
    },
    {
        "name": "ECS-12vCPU-48GB-RedHat-On-Demand",
        "price": 2.99,
        "vcpu": "12",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104800MO"
    },
    {
        "name": "ECS-28vCPU-56GB-Linux-3Yrs-PartUpFront",
        "price": 1367.07,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205636PU"
    },
    {
        "name": "ECS-20vCPU-80GB-RedHat-1Yr-NoUpFront",
        "price": 2686.68,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108012MO"
    },
    {
        "name": "ECS-10vCPU-20GB-RedHat-3Yrs-UpFront",
        "price": 649.7,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202036FU"
    },
    {
        "name": "ECS-10vCPU-20GB-RedHat-3Yrs-PartUpFront",
        "price": 699.04,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202036PU"
    },
    {
        "name": "ECS-10vCPU-20GB-WIN-On-Demand",
        "price": 1.89,
        "vcpu": "10",
        "ram": "20",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202000MO"
    },
    {
        "name": "ECS-4vCPU-32GB-RedHat-1Yr-NoUpFront",
        "price": 696.89,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0103212MO"
    },
    {
        "name": "ECS-24vCPU-96GB-RedHat-3Yrs-NoUpFront",
        "price": 2171.65,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0109636MO"
    },
    {
        "name": "ECS-28vCPU-112GB-RedHat-3Yrs-UpFront",
        "price": 2138.13,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0111236FU"
    },
    {
        "name": "ECS-12vCPU-48GB-WIN-3YrsNoUpFront",
        "price": 1339.44,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104836MO"
    },
    {
        "name": "ECS-24vCPU-96GB-WIN-3Yrs-PartUpFront",
        "price": 2598.51,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0109636PU"
    },
    {
        "name": "ECS-2vCPU-4GB-Linux-1Yr-PartUpFront",
        "price": 142.45,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200412PU"
    },
    {
        "name": "ECS-1vCPU-2GB-Linux-3YrsNoUpFront",
        "price": 52.84,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200236MO"
    },
    {
        "name": "ECS-4vCPU-8GB-WIN-3Yrs-NoUpFront",
        "price": 262.9,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200836MO"
    },
    {
        "name": "ECS-16vCPU-64GB-RedHat-3Yrs-PartUpFront",
        "price": 1252.88,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0106436PU"
    },
    {
        "name": "ECS-6vCPU-24GB-WIN-1Yr-NoUpFront",
        "price": 870.64,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0102412MO"
    },
    {
        "name": "ECS-1vCPU-8GB-Linux-1Yr-NoUpFront",
        "price": 119.66,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0100812MO"
    },
    {
        "name": "ECS-16vCPU-128GB-WIN-1Yr-PartUpFront",
        "price": 3440.28,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0112812PU"
    },
    {
        "name": "ECS-24vCPU-48GB-WIN-On-Demand",
        "price": 4.52,
        "vcpu": "24",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204800MO"
    },
    {
        "name": "ECS-18vCPU-36GB-WIN-3Yrs-NoUpFront",
        "price": 1183.05,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203636MO"
    },
    {
        "name": "ECS-30vCPU-60GB-WIN-1Yr-NoUpFront",
        "price": 2786.16,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206012MO"
    },
    {
        "name": "ECS-4vCPU-32GB-Linux-1Yr-NoUpFront",
        "price": 478.65,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0103212MO"
    },
    {
        "name": "ECS-2vCPU-16GB-Linux-On-Demand",
        "price": 0.53,
        "vcpu": "2",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0101600MO"
    },
    {
        "name": "ECS-26vCPU-52GB-Linux-3Yrs-NoUpFront",
        "price": 1373.96,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205236MO"
    },
    {
        "name": "ECS-12vCPU-96GB-WIN-1Yr-NoUpFront",
        "price": 2649.32,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0109612MO"
    },
    {
        "name": "ECS-18vCPU-144GB-Linux-3Yrs-UpFront",
        "price": 1395.15,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0114436FU"
    },
    {
        "name": "ECS-28vCPU-56GB-WIN-3Yrs-PartUpFront",
        "price": 1800.29,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205636PU"
    },
    {
        "name": "ECS-26vCPU-104GB-Linux-On-Demand",
        "price": 5.19,
        "vcpu": "26",
        "ram": "104",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0110400MO"
    },
    {
        "name": "ECS-2vCPU-4GB-Linux-1Yr-UpFront",
        "price": 140.15,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200412FU"
    },
    {
        "name": "ECS-14vCPU-28GB-Linux-3Yrs-NoUpFront",
        "price": 739.83,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202836MO"
    },
    {
        "name": "ECS-2vCPU-4GB-WIN-1Yr-UpFront",
        "price": 174.31,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200412FU"
    },
    {
        "name": "ECS-10vCPU-40GB-Linux-1Yr-NoUpFront",
        "price": 1011.8,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104012MO"
    },
    {
        "name": "ECS-12vCPU-48GB-WIN-3Yrs-UpFront",
        "price": 1272.47,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104836FU"
    },
    {
        "name": "ECS-22vCPU-88GB-RedHat-On-Demand",
        "price": 5.7,
        "vcpu": "22",
        "ram": "88",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108800MO"
    },
    {
        "name": "ECS-24vCPU-48GB-WIN-3Yrs-PartUpFront",
        "price": 1543.1,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204836PU"
    },
    {
        "name": "ECS-10vCPU-80GB-Linux-3Yrs-UpFront",
        "price": 775.09,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0108036FU"
    },
    {
        "name": "ECS-12vCPU-24GB-RedHat-1Yr-UpFront",
        "price": 1143.48,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202412FU"
    },
    {
        "name": "ECS-18vCPU-72GB-WIN-3YrsNoUpFront",
        "price": 2009.16,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0107236MO"
    },
    {
        "name": "ECS-30vCPU-60GB-RedHat-On-Demand",
        "price": 5.99,
        "vcpu": "30",
        "ram": "60",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206000MO"
    },
    {
        "name": "ECS-6vCPU-12GB-Linux-1Yr-NoUpFront",
        "price": 448.03,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201212MO"
    },
    {
        "name": "ECS-16vCPU-32GB-Linux-3Yrs-UpFront",
        "price": 726.04,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203236FU"
    },
    {
        "name": "ECS-14vCPU-28GB-Linux-1Yr-PartUpFront",
        "price": 997.16,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202812PU"
    },
    {
        "name": "ECS-28vCPU-56GB-Linux-1Yr-NoUpFront",
        "price": 2090.82,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205612MO"
    },
    {
        "name": "ECS-4vCPU-32GB-Linux-On-Demand",
        "price": 1.06,
        "vcpu": "4",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0103200MO"
    },
    {
        "name": "ECS-24vCPU-48GB-WIN-1Yr-PartUpFront",
        "price": 2126.05,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204812PU"
    },
    {
        "name": "ECS-6vCPU-24GB-RedHat-3Yrs-PartUpFront",
        "price": 592.28,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0102436PU"
    },
    {
        "name": "ECS-16vCPU-64GB-Linux-1Yr-PartUpFront",
        "price": 1538.61,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0106412PU"
    },
    {
        "name": "ECS-10vCPU-20GB-Linux-3Yrs-UpFront",
        "price": 453.78,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202036FU"
    },
    {
        "name": "ECS-22vCPU-44GB-Linux-3Yrs-NoUpFront",
        "price": 1162.59,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204436MO"
    },
    {
        "name": "ECS-1vCPU-4GB-WIN-3Yrs-UpFront",
        "price": 106.04,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100436FU"
    },
    {
        "name": "ECS-16vCPU-128GB-RedHat-3Yrs-PartUpFront",
        "price": 1405.73,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0112836PU"
    },
    {
        "name": "ECS-32vCPU-128GB-WIN-3YrsNoUpFront",
        "price": 3571.84,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112836MO"
    },
    {
        "name": "ECS-8vCPU-64GB-WIN-1Yr-NoUpFront",
        "price": 1766.22,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0106412MO"
    },
    {
        "name": "ECS-12vCPU-24GB-WIN-3Yrs-NoUpFront",
        "price": 788.7,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202436MO"
    },
    {
        "name": "ECS-12vCPU-24GB-Linux-On-Demand",
        "price": 1.82,
        "vcpu": "12",
        "ram": "24",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202400MO"
    },
    {
        "name": "ECS-2vCPU-8GB-RedHat-3Yrs-NoUpFront",
        "price": 352.95,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100836MO"
    },
    {
        "name": "ECS-2vCPU-4GB-WIN-3Yrs-NoUpFront",
        "price": 131.45,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200436MO"
    },
    {
        "name": "ECS-1vCPU-4GB-Linux-3Yrs-UpFront",
        "price": 61.88,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100436FU"
    },
    {
        "name": "ECS-16vCPU-64GB-Linux-On-Demand",
        "price": 3.2,
        "vcpu": "16",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0106400MO"
    },
    {
        "name": "ECS-24vCPU-48GB-Linux-3Yrs-PartUpFront",
        "price": 1171.78,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204836PU"
    },
    {
        "name": "ECS-12vCPU-96GB-Linux-3Yrs-NoUpFront",
        "price": 1028.01,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0109636MO"
    },
    {
        "name": "ECS-16vCPU-32GB-Linux-1Yr-UpFront",
        "price": 1121.23,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203212FU"
    },
    {
        "name": "ECS-6vCPU-48GB-Linux-1Yr-PartUpFront",
        "price": 677.18,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0104812PU"
    },
    {
        "name": "ECS-24vCPU-96GB-WIN-1Yr-PartUpFront",
        "price": 3402.18,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0109612PU"
    },
    {
        "name": "ECS-22vCPU-44GB-RedHat-3Yrs-NoUpFront",
        "price": 1666.75,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204436MO"
    },
    {
        "name": "ECS-10vCPU-20GB-Linux-3Yrs-PartUpFront",
        "price": 488.24,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202036PU"
    },
    {
        "name": "ECS-18vCPU-36GB-RedHat-1Yr-NoUpFront",
        "price": 2056.5,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203612MO"
    },
    {
        "name": "ECS-12vCPU-96GB-Linux-3Yrs-PartUpFront",
        "price": 946.42,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0109636PU"
    },
    {
        "name": "ECS-16vCPU-128GB-Linux-3Yrs-PartUpFront",
        "price": 1261.89,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0112836PU"
    },
    {
        "name": "ECS-2vCPU-8GB-WIN-3YrsNoUpFront",
        "price": 223.24,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100836MO"
    },
    {
        "name": "ECS-8vCPU-64GB-WIN-3Yrs-NoUpFront",
        "price": 1612.63,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0106436MO"
    },
    {
        "name": "ECS-12vCPU-48GB-RedHat-1Yr-NoUpFront",
        "price": 1514.24,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104812MO"
    },
    {
        "name": "ECS-16vCPU-128GB-RedHat-1Yr-UpFront",
        "price": 1987.42,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0112812FU"
    },
    {
        "name": "ECS-1vCPU-8GB-WIN-1Yr-UpFront",
        "price": 209.26,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0100812FU"
    },
    {
        "name": "ECS-20vCPU-80GB-RedHat-1Yr-UpFront",
        "price": 2486.85,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108012FU"
    },
    {
        "name": "ECS-14vCPU-112GB-Linux-1Yr-PartUpFront",
        "price": 1580.09,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0111212PU"
    },
    {
        "name": "ECS-14vCPU-28GB-RedHat-1Yr-NoUpFront",
        "price": 1367.81,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202812MO"
    },
    {
        "name": "ECS-32vCPU-64GB-RedHat-3Yrs-PartUpFront",
        "price": 2028.17,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206436PU"
    },
    {
        "name": "ECS-10vCPU-40GB-Linux-3Yrs-PartUpFront",
        "price": 660.6,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104036PU"
    },
    {
        "name": "ECS-20vCPU-40GB-RedHat-1Yr-PartUpFront",
        "price": 2104.03,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204012PU"
    },
    {
        "name": "ECS-1vCPU-2GB-RedHat-3Yrs-NoUpFront",
        "price": 281,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200236MO"
    },
    {
        "name": "ECS-2vCPU-4GB-RedHat-On-Demand",
        "price": 0.96,
        "vcpu": "2",
        "ram": "4",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200400MO"
    },
    {
        "name": "ECS-22vCPU-88GB-Linux-On-Demand",
        "price": 4.39,
        "vcpu": "22",
        "ram": "88",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108800MO"
    },
    {
        "name": "ECS-8vCPU-32GB-Linux-3Yrs-UpFront",
        "price": 495.03,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0103236FU"
    },
    {
        "name": "ECS-2vCPU-4GB-Linux-3YrsNoUpFront",
        "price": 105.69,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200436MO"
    },
    {
        "name": "ECS-4vCPU-32GB-Linux-3Yrs-NoUpFront",
        "price": 342.67,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0103236MO"
    },
    {
        "name": "ECS-4vCPU-32GB-Linux-1Yr-PartUpFront",
        "price": 451.45,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0103212PU"
    },
    {
        "name": "ECS-24vCPU-96GB-RedHat-3Yrs-UpFront",
        "price": 1890.61,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0109636FU"
    },
    {
        "name": "ECS-16vCPU-128GB-WIN-3Yrs-NoUpFront",
        "price": 3225.26,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0112836MO"
    },
    {
        "name": "ECS-6vCPU-12GB-WIN-3Yrs-UpFront",
        "price": 377.2,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201236FU"
    },
    {
        "name": "ECS-1vCPU-8GB-RedHat-1Yr-UpFront",
        "price": 314.86,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0100812FU"
    },
    {
        "name": "ECS-28vCPU-56GB-Linux-3Yrs-UpFront",
        "price": 1270.57,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205636FU"
    },
    {
        "name": "ECS-32vCPU-128GB-RedHat-3Yrs-UpFront",
        "price": 2385.64,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112836FU"
    },
    {
        "name": "ECS-28vCPU-112GB-Linux-3Yrs-UpFront",
        "price": 1732.61,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0111236FU"
    },
    {
        "name": "ECS-4vCPU-32GB-RedHat-1Yr-UpFront",
        "price": 649.37,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0103212FU"
    },
    {
        "name": "ECS-30vCPU-120GB-Linux-3Yrs-UpFront",
        "price": 1856.36,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112036FU"
    },
    {
        "name": "ECS-12vCPU-24GB-RedHat-3Yrs-NoUpFront",
        "price": 862.3,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202436MO"
    },
    {
        "name": "ECS-28vCPU-112GB-RedHat-1Yr-PartUpFront",
        "price": 3322.76,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0111212PU"
    },
    {
        "name": "ECS-26vCPU-52GB-RedHat-1Yr-UpFront",
        "price": 2490.56,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205212FU"
    },
    {
        "name": "ECS-30vCPU-60GB-RedHat-1Yr-PartUpFront",
        "price": 2816.29,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206012PU"
    },
    {
        "name": "ECS-22vCPU-88GB-RedHat-3Yrs-NoUpFront",
        "price": 2029.49,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108836MO"
    },
    {
        "name": "ECS-18vCPU-36GB-RedHat-3Yrs-NoUpFront",
        "price": 1455.37,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203636MO"
    },
    {
        "name": "ECS-12vCPU-96GB-RedHat-On-Demand",
        "price": 3.66,
        "vcpu": "12",
        "ram": "96",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0109600MO"
    },
    {
        "name": "ECS-16vCPU-32GB-WIN-3Yrs-NoUpFront",
        "price": 1051.6,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203236MO"
    },
    {
        "name": "ECS-10vCPU-20GB-WIN-1Yr-NoUpFront",
        "price": 928.72,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202012MO"
    },
    {
        "name": "ECS-4vCPU-16GB-Linux-1Yr-UpFront",
        "price": 374.62,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0101612FU"
    },
    {
        "name": "ECS-8vCPU-32GB-Linux-On-Demand",
        "price": 1.6,
        "vcpu": "8",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0103200MO"
    },
    {
        "name": "ECS-2vCPU-4GB-Linux-1Yr-NoUpFront",
        "price": 149.34,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200412MO"
    },
    {
        "name": "ECS-6vCPU-12GB-Linux-1Yr-PartUpFront",
        "price": 427.35,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201212PU"
    },
    {
        "name": "ECS-32vCPU-128GB-Linux-On-Demand",
        "price": 6.39,
        "vcpu": "32",
        "ram": "128",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112800MO"
    },
    {
        "name": "ECS-26vCPU-52GB-WIN-3Yrs-UpFront",
        "price": 1634.55,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205236FU"
    },
    {
        "name": "ECS-12vCPU-24GB-WIN-1Yr-UpFront",
        "price": 1045.88,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202412FU"
    },
    {
        "name": "ECS-1vCPU-4GB-WIN-3Yrs-PartUpFront",
        "price": 108.27,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100436PU"
    },
    {
        "name": "ECS-18vCPU-72GB-WIN-1Yr-PartUpFront",
        "price": 2551.63,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0107212PU"
    },
    {
        "name": "ECS-2vCPU-16GB-Linux-1Yr-NoUpFront",
        "price": 239.32,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0101612MO"
    },
    {
        "name": "ECS-32vCPU-128GB-Linux-1Yr-NoUpFront",
        "price": 3237.77,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112812MO"
    },
    {
        "name": "ECS-12vCPU-24GB-WIN-On-Demand",
        "price": 2.26,
        "vcpu": "12",
        "ram": "24",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202400MO"
    },
    {
        "name": "ECS-18vCPU-36GB-RedHat-3Yrs-PartUpFront",
        "price": 1344.63,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203636PU"
    },
    {
        "name": "ECS-10vCPU-20GB-Linux-1Yr-PartUpFront",
        "price": 712.26,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202012PU"
    },
    {
        "name": "ECS-4vCPU-32GB-WIN-1Yr-NoUpFront",
        "price": 883.11,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0103212MO"
    },
    {
        "name": "ECS-16vCPU-64GB-WIN-3Yrs-PartUpFront",
        "price": 1732.34,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0106436PU"
    },
    {
        "name": "ECS-32vCPU-128GB-RedHat-3Yrs-PartUpFront",
        "price": 2546.83,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112836PU"
    },
    {
        "name": "ECS-20vCPU-80GB-WIN-1Yr-NoUpFront",
        "price": 2902.12,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108012MO"
    },
    {
        "name": "ECS-18vCPU-72GB-RedHat-On-Demand",
        "price": 4.9,
        "vcpu": "18",
        "ram": "72",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0107200MO"
    },
    {
        "name": "ECS-12vCPU-48GB-WIN-1Yr-PartUpFront",
        "price": 1701.09,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104812PU"
    },
    {
        "name": "ECS-4vCPU-8GB-RedHat-1Yr-UpFront",
        "price": 582.87,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200812FU"
    },
    {
        "name": "ECS-16vCPU-64GB-Linux-1Yr-UpFront",
        "price": 1498.47,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0106412FU"
    },
    {
        "name": "ECS-30vCPU-120GB-Linux-On-Demand",
        "price": 5.99,
        "vcpu": "30",
        "ram": "120",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112000MO"
    },
    {
        "name": "ECS-1vCPU-4GB-RedHat-1Yr-UpFront",
        "price": 371.41,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100412FU"
    },
    {
        "name": "ECS-2vCPU-16GB-RedHat-3Yrs-UpFront",
        "price": 296.38,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0101636FU"
    },
    {
        "name": "ECS-2vCPU-8GB-WIN-3Yrs-UpFront",
        "price": 212.08,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100836FU"
    },
    {
        "name": "ECS-2vCPU-8GB-RedHat-3Yrs-UpFront",
        "price": 307.28,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100836FU"
    },
    {
        "name": "ECS-1vCPU-4GB-Linux-1Yr-UpFront",
        "price": 93.65,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100412FU"
    },
    {
        "name": "ECS-4vCPU-8GB-WIN-1Yr-PartUpFront",
        "price": 354.34,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200812PU"
    },
    {
        "name": "ECS-10vCPU-80GB-Linux-1Yr-PartUpFront",
        "price": 1128.63,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0108012PU"
    },
    {
        "name": "ECS-4vCPU-16GB-RedHat-On-Demand",
        "price": 1.39,
        "vcpu": "4",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0101600MO"
    },
    {
        "name": "ECS-1vCPU-2GB-Linux-1Yr-PartUpFront",
        "price": 71.23,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200212PU"
    },
    {
        "name": "ECS-24vCPU-96GB-RedHat-1Yr-PartUpFront",
        "price": 2938.11,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0109612PU"
    },
    {
        "name": "ECS-10vCPU-20GB-WIN-1Yr-PartUpFront",
        "price": 885.86,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202012PU"
    },
    {
        "name": "ECS-22vCPU-88GB-WIN-1Yr-NoUpFront",
        "price": 3192.33,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108812MO"
    },
    {
        "name": "ECS-1vCPU-2GB-Linux-On-Demand",
        "price": 0.15,
        "vcpu": "1",
        "ram": "2",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200200MO"
    },
    {
        "name": "ECS-26vCPU-52GB-RedHat-1Yr-NoUpFront",
        "price": 2653.87,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205212MO"
    },
    {
        "name": "ECS-28vCPU-56GB-WIN-3Yrs-NoUpFront",
        "price": 1840.29,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205636MO"
    },
    {
        "name": "ECS-1vCPU-4GB-Linux-On-Demand",
        "price": 0.2,
        "vcpu": "1",
        "ram": "4",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100400MO"
    },
    {
        "name": "ECS-8vCPU-32GB-RedHat-1Yr-PartUpFront",
        "price": 1054.5,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0103212PU"
    },
    {
        "name": "ECS-32vCPU-64GB-RedHat-3Yrs-NoUpFront",
        "price": 2195.19,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206436MO"
    },
    {
        "name": "ECS-26vCPU-104GB-Linux-3Yrs-NoUpFront",
        "price": 1848,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0110436MO"
    },
    {
        "name": "ECS-22vCPU-44GB-RedHat-1Yr-UpFront",
        "price": 2210.25,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204412FU"
    },
    {
        "name": "ECS-22vCPU-44GB-RedHat-1Yr-PartUpFront",
        "price": 2246.48,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204412PU"
    },
    {
        "name": "ECS-32vCPU-128GB-RedHat-On-Demand",
        "price": 7.7,
        "vcpu": "32",
        "ram": "128",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112800MO"
    },
    {
        "name": "ECS-22vCPU-44GB-RedHat-1Yr-NoUpFront",
        "price": 2355.18,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204412MO"
    },
    {
        "name": "ECS-24vCPU-96GB-Linux-1Yr-UpFront",
        "price": 2247.71,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0109612FU"
    },
    {
        "name": "ECS-4vCPU-8GB-WIN-3Yrs-PartUpFront",
        "price": 257.18,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200836PU"
    },
    {
        "name": "ECS-26vCPU-104GB-WIN-3Yrs-UpFront",
        "price": 2757.01,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0110436FU"
    },
    {
        "name": "ECS-1vCPU-2GB-RedHat-1Yr-UpFront",
        "price": 372.64,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200212FU"
    },
    {
        "name": "ECS-14vCPU-56GB-Linux-1Yr-PartUpFront",
        "price": 1346.28,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0105612PU"
    },
    {
        "name": "ECS-4vCPU-32GB-WIN-1Yr-UpFront",
        "price": 837.03,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0103212FU"
    },
    {
        "name": "ECS-10vCPU-20GB-Linux-On-Demand",
        "price": 1.52,
        "vcpu": "10",
        "ram": "20",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202000MO"
    },
    {
        "name": "ECS-2vCPU-4GB-RedHat-1Yr-PartUpFront",
        "price": 449.97,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200412PU"
    },
    {
        "name": "ECS-6vCPU-12GB-WIN-1Yr-PartUpFront",
        "price": 531.51,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201212PU"
    },
    {
        "name": "ECS-4vCPU-16GB-Linux-3Yrs-NoUpFront",
        "price": 284.31,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0101636MO"
    },
    {
        "name": "ECS-26vCPU-104GB-Linux-1Yr-NoUpFront",
        "price": 2630.69,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0110412MO"
    },
    {
        "name": "ECS-28vCPU-56GB-WIN-1Yr-UpFront",
        "price": 2440.39,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205612FU"
    },
    {
        "name": "ECS-8vCPU-64GB-Linux-3Yrs-PartUpFront",
        "price": 630.95,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0106436PU"
    },
    {
        "name": "ECS-1vCPU-2GB-WIN-3Yrs-NoUpFront",
        "price": 65.72,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200236MO"
    },
    {
        "name": "ECS-6vCPU-12GB-Linux-3Yrs-PartUpFront",
        "price": 292.94,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201236PU"
    },
    {
        "name": "ECS-26vCPU-104GB-WIN-1Yr-PartUpFront",
        "price": 3685.69,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0110412PU"
    },
    {
        "name": "ECS-24vCPU-48GB-WIN-3Yrs-UpFront",
        "price": 1508.81,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204836FU"
    },
    {
        "name": "ECS-30vCPU-60GB-Linux-3Yrs-NoUpFront",
        "price": 1585.34,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206036MO"
    },
    {
        "name": "ECS-28vCPU-56GB-Linux-1Yr-PartUpFront",
        "price": 1994.32,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205612PU"
    },
    {
        "name": "ECS-12vCPU-48GB-WIN-On-Demand",
        "price": 3.2,
        "vcpu": "12",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104800MO"
    },
    {
        "name": "ECS-14vCPU-28GB-RedHat-3Yrs-PartUpFront",
        "price": 894.34,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202836PU"
    },
    {
        "name": "ECS-22vCPU-88GB-Linux-1Yr-UpFront",
        "price": 2060.4,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108812FU"
    },
    {
        "name": "ECS-20vCPU-80GB-RedHat-3Yrs-UpFront",
        "price": 1643.1,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108036FU"
    },
    {
        "name": "ECS-1vCPU-2GB-Linux-3Yrs-PartUpFront",
        "price": 48.82,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200236PU"
    },
    {
        "name": "ECS-26vCPU-52GB-WIN-1Yr-UpFront",
        "price": 2266.08,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205212FU"
    },
    {
        "name": "ECS-18vCPU-144GB-RedHat-1Yr-UpFront",
        "price": 2456.42,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0114412FU"
    },
    {
        "name": "ECS-8vCPU-64GB-RedHat-3Yrs-PartUpFront",
        "price": 774.79,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0106436PU"
    },
    {
        "name": "ECS-4vCPU-8GB-RedHat-1Yr-NoUpFront",
        "price": 621.09,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200812MO"
    },
    {
        "name": "ECS-22vCPU-44GB-RedHat-On-Demand",
        "price": 4.78,
        "vcpu": "22",
        "ram": "44",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204400MO"
    },
    {
        "name": "ECS-20vCPU-80GB-WIN-3Yrs-UpFront",
        "price": 2120.78,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108036FU"
    },
    {
        "name": "ECS-6vCPU-24GB-RedHat-1Yr-NoUpFront",
        "price": 907.16,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0102412MO"
    },
    {
        "name": "ECS-18vCPU-144GB-RedHat-3Yrs-PartUpFront",
        "price": 1737.47,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0114436PU"
    },
    {
        "name": "ECS-18vCPU-72GB-Linux-3Yrs-PartUpFront",
        "price": 1189.08,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0107236PU"
    },
    {
        "name": "ECS-2vCPU-16GB-RedHat-1Yr-NoUpFront",
        "price": 457.56,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0101612MO"
    },
    {
        "name": "ECS-24vCPU-48GB-WIN-3Yrs-NoUpFront",
        "price": 1577.4,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204836MO"
    },
    {
        "name": "ECS-4vCPU-32GB-RedHat-3Yrs-UpFront",
        "price": 451.39,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0103236FU"
    },
    {
        "name": "ECS-2vCPU-16GB-RedHat-3Yrs-NoUpFront",
        "price": 327.57,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0101636MO"
    },
    {
        "name": "ECS-16vCPU-64GB-Linux-3Yrs-UpFront",
        "price": 990.06,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0106436FU"
    },
    {
        "name": "ECS-2vCPU-16GB-WIN-1Yr-UpFront",
        "price": 418.52,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0101612FU"
    },
    {
        "name": "ECS-6vCPU-48GB-RedHat-On-Demand",
        "price": 2.07,
        "vcpu": "6",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0104800MO"
    },
    {
        "name": "ECS-1vCPU-4GB-RedHat-1Yr-NoUpFront",
        "price": 401.26,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100412MO"
    },
    {
        "name": "ECS-16vCPU-64GB-WIN-3Yrs-UpFront",
        "price": 1696.62,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0106436FU"
    },
    {
        "name": "ECS-32vCPU-128GB-Linux-1Yr-PartUpFront",
        "price": 3077.22,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112812PU"
    },
    {
        "name": "ECS-6vCPU-24GB-Linux-1Yr-UpFront",
        "price": 561.93,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0102412FU"
    },
    {
        "name": "ECS-32vCPU-64GB-WIN-3Yrs-UpFront",
        "price": 2011.75,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206436FU"
    },
    {
        "name": "ECS-16vCPU-64GB-Linux-3Yrs-NoUpFront",
        "price": 1137.23,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0106436MO"
    },
    {
        "name": "ECS-22vCPU-88GB-Linux-3Yrs-PartUpFront",
        "price": 1453.32,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108836PU"
    },
    {
        "name": "ECS-1vCPU-8GB-RedHat-On-Demand",
        "price": 0.75,
        "vcpu": "1",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0100800MO"
    },
    {
        "name": "ECS-32vCPU-64GB-RedHat-3Yrs-UpFront",
        "price": 1885,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206436FU"
    },
    {
        "name": "ECS-1vCPU-4GB-WIN-1Yr-NoUpFront",
        "price": 145.11,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100412MO"
    },
    {
        "name": "ECS-2vCPU-8GB-Linux-1Yr-NoUpFront",
        "price": 202.36,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100812MO"
    },
    {
        "name": "ECS-18vCPU-144GB-RedHat-1Yr-NoUpFront",
        "price": 2636.16,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0114412MO"
    },
    {
        "name": "ECS-2vCPU-8GB-WIN-1Yr-UpFront",
        "price": 276.82,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100812FU"
    },
    {
        "name": "ECS-20vCPU-80GB-Linux-1Yr-NoUpFront",
        "price": 2023.6,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108012MO"
    },
    {
        "name": "ECS-4vCPU-16GB-RedHat-3Yrs-NoUpFront",
        "price": 495.11,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0101636MO"
    },
    {
        "name": "ECS-1vCPU-8GB-Linux-1Yr-UpFront",
        "price": 111.5,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0100812FU"
    },
    {
        "name": "ECS-18vCPU-36GB-Linux-On-Demand",
        "price": 2.73,
        "vcpu": "18",
        "ram": "36",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203600MO"
    },
    {
        "name": "ECS-8vCPU-32GB-WIN-3YrsNoUpFront",
        "price": 892.96,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0103236MO"
    },
    {
        "name": "ECS-10vCPU-80GB-RedHat-1Yr-PartUpFront",
        "price": 1334.47,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0108012PU"
    },
    {
        "name": "ECS-32vCPU-128GB-Linux-3Yrs-NoUpFront",
        "price": 2274.46,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112836MO"
    },
    {
        "name": "ECS-4vCPU-16GB-Linux-3Yrs-PartUpFront",
        "price": 264.24,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0101636PU"
    },
    {
        "name": "ECS-18vCPU-144GB-WIN-3Yrs-NoUpFront",
        "price": 3628.42,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0114436MO"
    },
    {
        "name": "ECS-12vCPU-96GB-WIN-1Yr-UpFront",
        "price": 2511.1,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0109612FU"
    },
    {
        "name": "ECS-6vCPU-12GB-WIN-3Yrs-NoUpFront",
        "price": 394.35,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201236MO"
    },
    {
        "name": "ECS-4vCPU-16GB-WIN-1Yr-UpFront",
        "price": 553.64,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0101612FU"
    },
    {
        "name": "ECS-16vCPU-128GB-Linux-On-Demand",
        "price": 4.23,
        "vcpu": "16",
        "ram": "128",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0112800MO"
    },
    {
        "name": "ECS-1vCPU-2GB-WIN-On-Demand",
        "price": 0.19,
        "vcpu": "1",
        "ram": "2",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200200MO"
    },
    {
        "name": "ECS-1vCPU-8GB-WIN-On-Demand",
        "price": 0.37,
        "vcpu": "1",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0100800MO"
    },
    {
        "name": "ECS-14vCPU-112GB-WIN-1Yr-PartUpFront",
        "price": 3010.25,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0111212PU"
    },
    {
        "name": "ECS-8vCPU-64GB-RedHat-1Yr-PartUpFront",
        "price": 1108.75,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0106412PU"
    },
    {
        "name": "ECS-28vCPU-112GB-Linux-1Yr-NoUpFront",
        "price": 2833.05,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0111212MO"
    },
    {
        "name": "ECS-8vCPU-32GB-Linux-1Yr-NoUpFront",
        "price": 809.44,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0103212MO"
    },
    {
        "name": "ECS-18vCPU-144GB-Linux-3Yrs-PartUpFront",
        "price": 1419.63,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0114436PU"
    },
    {
        "name": "ECS-6vCPU-12GB-WIN-1Yr-NoUpFront",
        "price": 557.23,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201212MO"
    },
    {
        "name": "ECS-6vCPU-48GB-WIN-On-Demand",
        "price": 2.24,
        "vcpu": "6",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0104800MO"
    },
    {
        "name": "ECS-30vCPU-60GB-RedHat-3Yrs-PartUpFront",
        "price": 1930.52,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206036PU"
    },
    {
        "name": "ECS-20vCPU-40GB-RedHat-3Yrs-NoUpFront",
        "price": 1561.06,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204036MO"
    },
    {
        "name": "ECS-26vCPU-52GB-Linux-On-Demand",
        "price": 3.94,
        "vcpu": "26",
        "ram": "52",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205200MO"
    },
    {
        "name": "ECS-28vCPU-56GB-Linux-3Yrs-NoUpFront",
        "price": 1479.65,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205636MO"
    },
    {
        "name": "ECS-8vCPU-64GB-RedHat-On-Demand",
        "price": 2.6,
        "vcpu": "8",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0106400MO"
    },
    {
        "name": "ECS-26vCPU-52GB-WIN-3Yrs-PartUpFront",
        "price": 1671.7,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205236PU"
    },
    {
        "name": "ECS-4vCPU-8GB-Linux-3YrsNoUpFront",
        "price": 211.38,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200836MO"
    },
    {
        "name": "ECS-6vCPU-12GB-RedHat-1Yr-PartUpFront",
        "price": 734.87,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201212PU"
    },
    {
        "name": "ECS-20vCPU-40GB-RedHat-3Yrs-PartUpFront",
        "price": 1442.28,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204036PU"
    },
    {
        "name": "ECS-4vCPU-8GB-Linux-On-Demand",
        "price": 0.61,
        "vcpu": "4",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200800MO"
    },
    {
        "name": "ECS-14vCPU-28GB-WIN-1Yr-UpFront",
        "price": 1220.2,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202812FU"
    },
    {
        "name": "ECS-2vCPU-4GB-WIN-1Yr-PartUpFront",
        "price": 177.17,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200412PU"
    },
    {
        "name": "ECS-12vCPU-24GB-Linux-3Yrs-NoUpFront",
        "price": 634.14,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202436MO"
    },
    {
        "name": "ECS-24vCPU-48GB-RedHat-1Yr-UpFront",
        "price": 2350.4,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204812FU"
    },
    {
        "name": "ECS-26vCPU-104GB-WIN-1Yr-UpFront",
        "price": 3598.63,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0110412FU"
    },
    {
        "name": "ECS-10vCPU-40GB-RedHat-1Yr-PartUpFront",
        "price": 1246.83,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104012PU"
    },
    {
        "name": "ECS-2vCPU-4GB-Linux-3Yrs-PartUpFront",
        "price": 97.65,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200436PU"
    },
    {
        "name": "ECS-10vCPU-20GB-Linux-1Yr-NoUpFront",
        "price": 746.72,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202012MO"
    },
    {
        "name": "ECS-8vCPU-32GB-WIN-3Yrs-PartUpFront",
        "price": 866.17,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0103236PU"
    },
    {
        "name": "ECS-12vCPU-96GB-RedHat-1Yr-UpFront",
        "price": 1541.4,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0109612FU"
    },
    {
        "name": "ECS-18vCPU-72GB-Linux-1Yr-NoUpFront",
        "price": 1821.24,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0107212MO"
    },
    {
        "name": "ECS-28vCPU-56GB-RedHat-3Yrs-UpFront",
        "price": 1703.49,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205636FU"
    },
    {
        "name": "ECS-8vCPU-64GB-WIN-3Yrs-UpFront",
        "price": 1551.2,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0106436FU"
    },
    {
        "name": "ECS-22vCPU-88GB-Linux-3Yrs-UpFront",
        "price": 1361.33,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108836FU"
    },
    {
        "name": "ECS-24vCPU-96GB-Linux-3Yrs-NoUpFront",
        "price": 1705.85,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0109636MO"
    },
    {
        "name": "ECS-6vCPU-24GB-Linux-On-Demand",
        "price": 1.2,
        "vcpu": "6",
        "ram": "24",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0102400MO"
    },
    {
        "name": "ECS-30vCPU-60GB-RedHat-3Yrs-UpFront",
        "price": 1794.25,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206036FU"
    },
    {
        "name": "ECS-28vCPU-112GB-Linux-3Yrs-PartUpFront",
        "price": 1849.67,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0111236PU"
    },
    {
        "name": "ECS-1vCPU-8GB-WIN-1Yr-NoUpFront",
        "price": 220.78,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0100812MO"
    },
    {
        "name": "ECS-1vCPU-8GB-Linux-1Yr-PartUpFront",
        "price": 112.86,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0100812PU"
    },
    {
        "name": "ECS-4vCPU-8GB-Linux-1Yr-PartUpFront",
        "price": 284.9,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200812PU"
    },
    {
        "name": "ECS-16vCPU-128GB-WIN-On-Demand",
        "price": 5.97,
        "vcpu": "16",
        "ram": "128",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0112800MO"
    },
    {
        "name": "ECS-14vCPU-28GB-WIN-On-Demand",
        "price": 2.64,
        "vcpu": "14",
        "ram": "28",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202800MO"
    },
    {
        "name": "ECS-12vCPU-48GB-RedHat-3Yrs-NoUpFront",
        "price": 1063.72,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104836MO"
    },
    {
        "name": "ECS-4vCPU-16GB-RedHat-1Yr-UpFront",
        "price": 652.38,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0101612FU"
    },
    {
        "name": "ECS-18vCPU-72GB-RedHat-1Yr-PartUpFront",
        "price": 2361.13,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0107212PU"
    },
    {
        "name": "ECS-10vCPU-40GB-RedHat-3Yrs-UpFront",
        "price": 802.31,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104036FU"
    },
    {
        "name": "ECS-14vCPU-28GB-RedHat-3Yrs-UpFront",
        "price": 831.21,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202836FU"
    },
    {
        "name": "ECS-8vCPU-64GB-RedHat-1Yr-NoUpFront",
        "price": 1175.54,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0106412MO"
    },
    {
        "name": "ECS-2vCPU-4GB-Linux-On-Demand",
        "price": 0.3,
        "vcpu": "2",
        "ram": "4",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200400MO"
    },
    {
        "name": "ECS-1vCPU-4GB-RedHat-1Yr-PartUpFront",
        "price": 381.36,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100412PU"
    },
    {
        "name": "ECS-18vCPU-36GB-RedHat-On-Demand",
        "price": 4.17,
        "vcpu": "18",
        "ram": "36",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203600MO"
    },
    {
        "name": "ECS-1vCPU-4GB-Linux-3Yrs-PartUpFront",
        "price": 66.06,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100436PU"
    },
    {
        "name": "ECS-28vCPU-112GB-Linux-1Yr-UpFront",
        "price": 2622.32,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0111212FU"
    },
    {
        "name": "ECS-30vCPU-120GB-WIN-3Yrs-UpFront",
        "price": 3181.17,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112036FU"
    },
    {
        "name": "ECS-20vCPU-40GB-WIN-3Yrs-NoUpFront",
        "price": 1314.5,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204036MO"
    },
    {
        "name": "ECS-2vCPU-4GB-WIN-3Yrs-UpFront",
        "price": 125.73,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200436FU"
    },
    {
        "name": "ECS-6vCPU-24GB-Linux-1Yr-PartUpFront",
        "price": 576.98,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0102412PU"
    },
    {
        "name": "ECS-32vCPU-128GB-Linux-1Yr-UpFront",
        "price": 2996.94,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112812FU"
    },
    {
        "name": "ECS-32vCPU-64GB-Linux-3Yrs-UpFront",
        "price": 1452.08,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206436FU"
    },
    {
        "name": "ECS-18vCPU-144GB-RedHat-1Yr-PartUpFront",
        "price": 2486.38,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0114412PU"
    },
    {
        "name": "ECS-10vCPU-80GB-WIN-1Yr-NoUpFront",
        "price": 2207.77,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0108012MO"
    },
    {
        "name": "ECS-10vCPU-40GB-WIN-3YrsNoUpFront",
        "price": 1116.2,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104036MO"
    },
    {
        "name": "ECS-8vCPU-16GB-Linux-3Yrs-PartUpFront",
        "price": 390.59,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201636PU"
    },
    {
        "name": "ECS-18vCPU-36GB-WIN-1Yr-PartUpFront",
        "price": 1594.54,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203612PU"
    },
    {
        "name": "ECS-10vCPU-20GB-WIN-1Yr-UpFront",
        "price": 871.57,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202012FU"
    },
    {
        "name": "ECS-10vCPU-20GB-WIN-3Yrs-PartUpFront",
        "price": 642.96,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202036PU"
    },
    {
        "name": "ECS-16vCPU-32GB-Linux-1Yr-PartUpFront",
        "price": 1139.61,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203212PU"
    },
    {
        "name": "ECS-26vCPU-104GB-RedHat-1Yr-UpFront",
        "price": 3048.77,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0110412FU"
    },
    {
        "name": "ECS-26vCPU-104GB-Linux-1Yr-PartUpFront",
        "price": 2500.24,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0110412PU"
    },
    {
        "name": "ECS-14vCPU-56GB-RedHat-1Yr-NoUpFront",
        "price": 1716.6,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0105612MO"
    },
    {
        "name": "ECS-4vCPU-16GB-WIN-1Yr-NoUpFront",
        "price": 580.42,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0101612MO"
    },
    {
        "name": "ECS-6vCPU-48GB-RedHat-1Yr-UpFront",
        "price": 872.38,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0104812FU"
    },
    {
        "name": "ECS-8vCPU-16GB-Linux-1Yr-NoUpFront",
        "price": 597.38,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201612MO"
    },
    {
        "name": "ECS-12vCPU-96GB-WIN-1Yr-PartUpFront",
        "price": 2580.21,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0109612PU"
    },
    {
        "name": "ECS-6vCPU-48GB-WIN-3Yrs-PartUpFront",
        "price": 1186.44,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0104836PU"
    },
    {
        "name": "ECS-18vCPU-72GB-RedHat-3Yrs-PartUpFront",
        "price": 1622,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0107236PU"
    },
    {
        "name": "ECS-4vCPU-32GB-RedHat-1Yr-PartUpFront",
        "price": 657.29,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0103212PU"
    },
    {
        "name": "ECS-24vCPU-48GB-Linux-1Yr-NoUpFront",
        "price": 1792.13,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204812MO"
    },
    {
        "name": "ECS-14vCPU-112GB-RedHat-3Yrs-PartUpFront",
        "price": 1248,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0111236PU"
    },
    {
        "name": "ECS-6vCPU-48GB-WIN-3Yrs-UpFront",
        "price": 1163.4,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0104836FU"
    },
    {
        "name": "ECS-20vCPU-40GB-RedHat-1Yr-UpFront",
        "price": 2070.1,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204012FU"
    },
    {
        "name": "ECS-14vCPU-112GB-Linux-On-Demand",
        "price": 3.7,
        "vcpu": "14",
        "ram": "112",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0111200MO"
    },
    {
        "name": "ECS-30vCPU-60GB-Linux-1Yr-PartUpFront",
        "price": 2136.77,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206012PU"
    },
    {
        "name": "ECS-26vCPU-104GB-Linux-1Yr-UpFront",
        "price": 2435.01,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0110412FU"
    },
    {
        "name": "ECS-6vCPU-48GB-WIN-3Yrs-NoUpFront",
        "price": 1209.47,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0104836MO"
    },
    {
        "name": "ECS-30vCPU-120GB-RedHat-3Yrs-NoUpFront",
        "price": 2598.11,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112036MO"
    },
    {
        "name": "ECS-22vCPU-44GB-WIN-1Yr-PartUpFront",
        "price": 1948.88,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204412PU"
    },
    {
        "name": "ECS-16vCPU-64GB-WIN-1Yr-NoUpFront",
        "price": 2321.7,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0106412MO"
    },
    {
        "name": "ECS-22vCPU-44GB-WIN-3Yrs-PartUpFront",
        "price": 1414.51,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204436PU"
    },
    {
        "name": "ECS-8vCPU-64GB-RedHat-3Yrs-NoUpFront",
        "price": 841.58,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0106436MO"
    },
    {
        "name": "ECS-24vCPU-96GB-Linux-1Yr-NoUpFront",
        "price": 2428.32,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0109612MO"
    },
    {
        "name": "ECS-10vCPU-80GB-WIN-1Yr-PartUpFront",
        "price": 2150.18,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0108012PU"
    },
    {
        "name": "ECS-30vCPU-60GB-Linux-3Yrs-UpFront",
        "price": 1361.33,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206036FU"
    },
    {
        "name": "ECS-12vCPU-96GB-Linux-1Yr-UpFront",
        "price": 1338.04,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0109612FU"
    },
    {
        "name": "ECS-16vCPU-32GB-Linux-3Yrs-NoUpFront",
        "price": 845.52,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203236MO"
    },
    {
        "name": "ECS-28vCPU-112GB-WIN-On-Demand",
        "price": 7.47,
        "vcpu": "28",
        "ram": "112",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0111200MO"
    },
    {
        "name": "ECS-18vCPU-144GB-WIN-3Yrs-PartUpFront",
        "price": 3559.31,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0114436PU"
    },
    {
        "name": "ECS-30vCPU-120GB-WIN-1Yr-PartUpFront",
        "price": 4252.72,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112012PU"
    },
    {
        "name": "ECS-16vCPU-32GB-WIN-1Yr-NoUpFront",
        "price": 1485.95,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203212MO"
    },
    {
        "name": "ECS-20vCPU-80GB-WIN-On-Demand",
        "price": 5.33,
        "vcpu": "20",
        "ram": "80",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108000MO"
    },
    {
        "name": "ECS-4vCPU-16GB-RedHat-1Yr-PartUpFront",
        "price": 669.85,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0101612PU"
    },
    {
        "name": "ECS-8vCPU-32GB-WIN-On-Demand",
        "price": 2.13,
        "vcpu": "8",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0103200MO"
    },
    {
        "name": "ECS-18vCPU-144GB-RedHat-On-Demand",
        "price": 5.82,
        "vcpu": "18",
        "ram": "144",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0114400MO"
    },
    {
        "name": "ECS-8vCPU-16GB-RedHat-1Yr-NoUpFront",
        "price": 919.78,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201612MO"
    },
    {
        "name": "ECS-6vCPU-48GB-WIN-1Yr-NoUpFront",
        "price": 1324.66,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0104812MO"
    },
    {
        "name": "ECS-26vCPU-52GB-WIN-1Yr-NoUpFront",
        "price": 2414.67,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205212MO"
    },
    {
        "name": "ECS-32vCPU-64GB-Linux-3Yrs-PartUpFront",
        "price": 1562.37,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206436PU"
    },
    {
        "name": "ECS-16vCPU-128GB-RedHat-1Yr-NoUpFront",
        "price": 2132.84,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0112812MO"
    },
    {
        "name": "ECS-30vCPU-120GB-Linux-3Yrs-NoUpFront",
        "price": 2132.31,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112036MO"
    },
    {
        "name": "ECS-2vCPU-8GB-WIN-3Yrs-PartUpFront",
        "price": 216.54,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100836PU"
    },
    {
        "name": "ECS-22vCPU-88GB-WIN-3Yrs-PartUpFront",
        "price": 2381.97,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108836PU"
    },
    {
        "name": "ECS-14vCPU-56GB-RedHat-1Yr-PartUpFront",
        "price": 1631.48,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0105612PU"
    },
    {
        "name": "ECS-12vCPU-48GB-Linux-On-Demand",
        "price": 2.4,
        "vcpu": "12",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104800MO"
    },
    {
        "name": "ECS-4vCPU-8GB-RedHat-On-Demand",
        "price": 1.26,
        "vcpu": "4",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200800MO"
    },
    {
        "name": "ECS-20vCPU-80GB-Linux-1Yr-UpFront",
        "price": 1873.09,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108012FU"
    },
    {
        "name": "ECS-4vCPU-8GB-RedHat-3Yrs-PartUpFront",
        "price": 406.1,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200836PU"
    },
    {
        "name": "ECS-24vCPU-48GB-Linux-3Yrs-NoUpFront",
        "price": 1268.28,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204836MO"
    },
    {
        "name": "ECS-14vCPU-28GB-Linux-3Yrs-UpFront",
        "price": 635.29,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202836FU"
    },
    {
        "name": "ECS-22vCPU-88GB-Linux-1Yr-NoUpFront",
        "price": 2225.96,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108812MO"
    },
    {
        "name": "ECS-14vCPU-56GB-Linux-3Yrs-NoUpFront",
        "price": 995.08,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0105636MO"
    },
    {
        "name": "ECS-16vCPU-32GB-Linux-On-Demand",
        "price": 2.43,
        "vcpu": "16",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203200MO"
    },
    {
        "name": "ECS-4vCPU-16GB-WIN-On-Demand",
        "price": 1.07,
        "vcpu": "4",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0101600MO"
    },
    {
        "name": "ECS-16vCPU-128GB-WIN-3Yrs-UpFront",
        "price": 3102.4,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0112836FU"
    },
    {
        "name": "ECS-10vCPU-40GB-RedHat-3Yrs-PartUpFront",
        "price": 856.52,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104036PU"
    },
    {
        "name": "ECS-4vCPU-32GB-Linux-3Yrs-PartUpFront",
        "price": 315.47,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0103236PU"
    },
    {
        "name": "ECS-30vCPU-120GB-WIN-1Yr-UpFront",
        "price": 4152.26,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112012FU"
    },
    {
        "name": "ECS-1vCPU-2GB-WIN-3Yrs-UpFront",
        "price": 62.87,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200236FU"
    },
    {
        "name": "ECS-24vCPU-96GB-WIN-3YrsNoUpFront",
        "price": 2678.88,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0109636MO"
    },
    {
        "name": "ECS-14vCPU-28GB-Linux-1Yr-UpFront",
        "price": 981.08,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202812FU"
    },
    {
        "name": "ECS-1vCPU-4GB-WIN-1Yr-PartUpFront",
        "price": 141.76,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100412PU"
    },
    {
        "name": "ECS-1vCPU-8GB-RedHat-1Yr-PartUpFront",
        "price": 318.7,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0100812PU"
    },
    {
        "name": "ECS-6vCPU-12GB-RedHat-1Yr-NoUpFront",
        "price": 770.43,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201212MO"
    },
    {
        "name": "ECS-14vCPU-112GB-RedHat-3Yrs-UpFront",
        "price": 1226.48,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0111236FU"
    },
    {
        "name": "ECS-24vCPU-96GB-Linux-3Yrs-PartUpFront",
        "price": 1585.44,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0109636PU"
    },
    {
        "name": "ECS-12vCPU-48GB-WIN-1Yr-UpFront",
        "price": 1660.91,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104812FU"
    },
    {
        "name": "ECS-6vCPU-12GB-RedHat-3Yrs-PartUpFront",
        "price": 503.74,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201236PU"
    },
    {
        "name": "ECS-6vCPU-24GB-Linux-3Yrs-UpFront",
        "price": 371.27,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0102436FU"
    },
    {
        "name": "ECS-20vCPU-80GB-RedHat-3Yrs-NoUpFront",
        "price": 1887.34,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108036MO"
    },
    {
        "name": "ECS-26vCPU-52GB-RedHat-On-Demand",
        "price": 5.39,
        "vcpu": "26",
        "ram": "52",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205200MO"
    },
    {
        "name": "ECS-24vCPU-96GB-RedHat-1Yr-UpFront",
        "price": 2861.47,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0109612FU"
    },
    {
        "name": "ECS-8vCPU-64GB-Linux-1Yr-NoUpFront",
        "price": 957.3,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0106412MO"
    },
    {
        "name": "ECS-14vCPU-112GB-RedHat-1Yr-PartUpFront",
        "price": 1785.93,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0111212PU"
    },
    {
        "name": "ECS-1vCPU-4GB-WIN-On-Demand",
        "price": 0.27,
        "vcpu": "1",
        "ram": "4",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100400MO"
    },
    {
        "name": "ECS-1vCPU-4GB-WIN-3YrsNoUpFront",
        "price": 111.62,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100436MO"
    },
    {
        "name": "ECS-8vCPU-64GB-RedHat-3Yrs-UpFront",
        "price": 761.43,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0106436FU"
    },
    {
        "name": "ECS-8vCPU-16GB-WIN-1Yr-NoUpFront",
        "price": 742.98,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201612MO"
    },
    {
        "name": "ECS-26vCPU-52GB-Linux-1Yr-PartUpFront",
        "price": 1851.87,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205212PU"
    },
    {
        "name": "ECS-2vCPU-4GB-RedHat-1Yr-UpFront",
        "price": 442.71,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200412FU"
    },
    {
        "name": "ECS-1vCPU-2GB-RedHat-1Yr-PartUpFront",
        "price": 378.75,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200212PU"
    },
    {
        "name": "ECS-16vCPU-32GB-RedHat-3Yrs-UpFront",
        "price": 921.96,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203236FU"
    },
    {
        "name": "ECS-12vCPU-96GB-WIN-On-Demand",
        "price": 4.48,
        "vcpu": "12",
        "ram": "96",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0109600MO"
    },
    {
        "name": "ECS-28vCPU-56GB-Linux-1Yr-UpFront",
        "price": 1962.15,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205612FU"
    },
    {
        "name": "ECS-20vCPU-40GB-Linux-3Yrs-NoUpFront",
        "price": 1056.9,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204036MO"
    },
    {
        "name": "ECS-24vCPU-48GB-RedHat-3Yrs-NoUpFront",
        "price": 1772.44,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204836MO"
    },
    {
        "name": "ECS-20vCPU-40GB-RedHat-1Yr-NoUpFront",
        "price": 2205.84,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204012MO"
    },
    {
        "name": "ECS-8vCPU-16GB-Linux-1Yr-UpFront",
        "price": 560.61,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201612FU"
    },
    {
        "name": "ECS-12vCPU-48GB-Linux-3Yrs-UpFront",
        "price": 742.55,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104836FU"
    },
    {
        "name": "ECS-30vCPU-60GB-WIN-1Yr-PartUpFront",
        "price": 2657.57,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206012PU"
    },
    {
        "name": "ECS-1vCPU-2GB-WIN-3Yrs-PartUpFront",
        "price": 64.3,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200236PU"
    },
    {
        "name": "ECS-26vCPU-104GB-Linux-3Yrs-PartUpFront",
        "price": 1717.55,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0110436PU"
    },
    {
        "name": "ECS-4vCPU-16GB-WIN-3YrsNoUpFront",
        "price": 446.48,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0101636MO"
    },
    {
        "name": "ECS-10vCPU-40GB-RedHat-1Yr-NoUpFront",
        "price": 1311.88,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104012MO"
    },
    {
        "name": "ECS-2vCPU-16GB-WIN-1Yr-NoUpFront",
        "price": 441.55,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0101612MO"
    },
    {
        "name": "ECS-20vCPU-80GB-RedHat-On-Demand",
        "price": 5.3,
        "vcpu": "20",
        "ram": "80",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108000MO"
    },
    {
        "name": "ECS-20vCPU-80GB-Linux-3Yrs-PartUpFront",
        "price": 1321.2,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108036PU"
    },
    {
        "name": "ECS-16vCPU-64GB-WIN-On-Demand",
        "price": 4.27,
        "vcpu": "16",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0106400MO"
    },
    {
        "name": "ECS-18vCPU-36GB-WIN-On-Demand",
        "price": 3.39,
        "vcpu": "18",
        "ram": "36",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203600MO"
    },
    {
        "name": "ECS-14vCPU-112GB-Linux-1Yr-NoUpFront",
        "price": 1675.27,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0111212MO"
    },
    {
        "name": "ECS-30vCPU-120GB-WIN-3Yrs-PartUpFront",
        "price": 3248.14,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112036PU"
    },
    {
        "name": "ECS-26vCPU-104GB-WIN-On-Demand",
        "price": 6.93,
        "vcpu": "26",
        "ram": "104",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0110400MO"
    },
    {
        "name": "ECS-14vCPU-112GB-WIN-On-Demand",
        "price": 5.23,
        "vcpu": "14",
        "ram": "112",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0111200MO"
    },
    {
        "name": "ECS-8vCPU-32GB-RedHat-3Yrs-NoUpFront",
        "price": 779.42,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0103236MO"
    },
    {
        "name": "ECS-10vCPU-80GB-WIN-1Yr-UpFront",
        "price": 2092.58,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0108012FU"
    },
    {
        "name": "ECS-16vCPU-64GB-RedHat-On-Demand",
        "price": 3.79,
        "vcpu": "16",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0106400MO"
    },
    {
        "name": "ECS-22vCPU-88GB-RedHat-3Yrs-UpFront",
        "price": 1766.85,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108836FU"
    },
    {
        "name": "ECS-2vCPU-8GB-Linux-On-Demand",
        "price": 0.4,
        "vcpu": "2",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100800MO"
    },
    {
        "name": "ECS-14vCPU-56GB-WIN-3Yrs-UpFront",
        "price": 1484.55,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0105636FU"
    },
    {
        "name": "ECS-12vCPU-96GB-RedHat-3Yrs-NoUpFront",
        "price": 1184.25,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0109636MO"
    },
    {
        "name": "ECS-30vCPU-60GB-Linux-3Yrs-PartUpFront",
        "price": 1464.72,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206036PU"
    },
    {
        "name": "ECS-32vCPU-128GB-WIN-1Yr-UpFront",
        "price": 4429.08,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112812FU"
    },
    {
        "name": "ECS-1vCPU-2GB-RedHat-1Yr-NoUpFront",
        "price": 397.07,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200212MO"
    },
    {
        "name": "ECS-10vCPU-40GB-Linux-3Yrs-UpFront",
        "price": 618.79,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104036FU"
    },
    {
        "name": "ECS-2vCPU-8GB-RedHat-1Yr-PartUpFront",
        "price": 477.53,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100812PU"
    },
    {
        "name": "ECS-18vCPU-72GB-WIN-On-Demand",
        "price": 4.8,
        "vcpu": "18",
        "ram": "72",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0107200MO"
    },
    {
        "name": "ECS-14vCPU-28GB-Linux-3Yrs-PartUpFront",
        "price": 683.54,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202836PU"
    },
    {
        "name": "ECS-6vCPU-24GB-RedHat-On-Demand",
        "price": 1.79,
        "vcpu": "6",
        "ram": "24",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0102400MO"
    },
    {
        "name": "ECS-14vCPU-112GB-WIN-3Yrs-PartUpFront",
        "price": 2768.35,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0111236PU"
    },
    {
        "name": "ECS-6vCPU-24GB-Linux-3Yrs-PartUpFront",
        "price": 396.36,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0102436PU"
    },
    {
        "name": "ECS-14vCPU-28GB-RedHat-3Yrs-NoUpFront",
        "price": 967.99,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202836MO"
    },
    {
        "name": "ECS-24vCPU-48GB-RedHat-On-Demand",
        "price": 5.08,
        "vcpu": "24",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204800MO"
    },
    {
        "name": "ECS-14vCPU-28GB-WIN-1Yr-NoUpFront",
        "price": 1300.21,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202812MO"
    },
    {
        "name": "ECS-8vCPU-16GB-WIN-3Yrs-NoUpFront",
        "price": 525.8,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201636MO"
    },
    {
        "name": "ECS-6vCPU-12GB-WIN-On-Demand",
        "price": 1.13,
        "vcpu": "6",
        "ram": "12",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201200MO"
    },
    {
        "name": "ECS-16vCPU-32GB-RedHat-On-Demand",
        "price": 3.08,
        "vcpu": "16",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203200MO"
    },
    {
        "name": "ECS-10vCPU-40GB-Linux-1Yr-PartUpFront",
        "price": 961.63,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104012PU"
    },
    {
        "name": "ECS-4vCPU-32GB-Linux-3Yrs-UpFront",
        "price": 310.03,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0103236FU"
    },
    {
        "name": "ECS-2vCPU-8GB-WIN-1Yr-NoUpFront",
        "price": 290.21,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100812MO"
    },
    {
        "name": "ECS-8vCPU-32GB-Linux-3Yrs-PartUpFront",
        "price": 528.48,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0103236PU"
    },
    {
        "name": "ECS-8vCPU-16GB-RedHat-1Yr-PartUpFront",
        "price": 877.32,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201612PU"
    },
    {
        "name": "ECS-6vCPU-24GB-WIN-On-Demand",
        "price": 1.6,
        "vcpu": "6",
        "ram": "24",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0102400MO"
    },
    {
        "name": "ECS-26vCPU-52GB-WIN-On-Demand",
        "price": 4.9,
        "vcpu": "26",
        "ram": "52",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205200MO"
    },
    {
        "name": "ECS-6vCPU-24GB-WIN-1Yr-PartUpFront",
        "price": 850.54,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0102412PU"
    },
    {
        "name": "ECS-8vCPU-32GB-WIN-1Yr-UpFront",
        "price": 1107.27,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0103212FU"
    },
    {
        "name": "ECS-6vCPU-12GB-WIN-1Yr-UpFront",
        "price": 522.94,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201212FU"
    },
    {
        "name": "ECS-18vCPU-36GB-WIN-1Yr-UpFront",
        "price": 1568.82,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203612FU"
    },
    {
        "name": "ECS-4vCPU-8GB-Linux-1Yr-UpFront",
        "price": 280.31,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200812FU"
    },
    {
        "name": "ECS-22vCPU-88GB-RedHat-1Yr-NoUpFront",
        "price": 2889.04,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108812MO"
    },
    {
        "name": "ECS-30vCPU-60GB-WIN-3Yrs-UpFront",
        "price": 1886.02,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206036FU"
    },
    {
        "name": "ECS-28vCPU-112GB-RedHat-1Yr-UpFront",
        "price": 3236.08,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0111212FU"
    },
    {
        "name": "ECS-20vCPU-80GB-Linux-3Yrs-UpFront",
        "price": 1237.58,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108036FU"
    },
    {
        "name": "ECS-24vCPU-96GB-Linux-1Yr-PartUpFront",
        "price": 2307.91,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0109612PU"
    },
    {
        "name": "ECS-18vCPU-72GB-WIN-1Yr-NoUpFront",
        "price": 2611.91,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0107212MO"
    },
    {
        "name": "ECS-16vCPU-128GB-WIN-3Yrs-PartUpFront",
        "price": 3163.83,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0112836PU"
    },
    {
        "name": "ECS-14vCPU-112GB-Linux-3Yrs-NoUpFront",
        "price": 1199.34,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0111236MO"
    },
    {
        "name": "ECS-12vCPU-24GB-Linux-1Yr-NoUpFront",
        "price": 896.06,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202412MO"
    },
    {
        "name": "ECS-28vCPU-56GB-RedHat-1Yr-UpFront",
        "price": 2630.71,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205612FU"
    },
    {
        "name": "ECS-4vCPU-16GB-Linux-On-Demand",
        "price": 0.8,
        "vcpu": "4",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0101600MO"
    },
    {
        "name": "ECS-12vCPU-24GB-WIN-1Yr-PartUpFront",
        "price": 1063.03,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202412PU"
    },
    {
        "name": "ECS-18vCPU-72GB-RedHat-3Yrs-NoUpFront",
        "price": 1745.19,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0107236MO"
    },
    {
        "name": "ECS-6vCPU-24GB-Linux-3Yrs-NoUpFront",
        "price": 426.46,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0102436MO"
    },
    {
        "name": "ECS-14vCPU-56GB-RedHat-3Yrs-PartUpFront",
        "price": 1120.76,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0105636PU"
    },
    {
        "name": "ECS-2vCPU-4GB-RedHat-1Yr-NoUpFront",
        "price": 471.74,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200412MO"
    },
    {
        "name": "ECS-4vCPU-32GB-RedHat-3Yrs-PartUpFront",
        "price": 459.31,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0103236PU"
    },
    {
        "name": "ECS-26vCPU-52GB-Linux-1Yr-NoUpFront",
        "price": 1941.47,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205212MO"
    },
    {
        "name": "ECS-28vCPU-112GB-Linux-On-Demand",
        "price": 5.59,
        "vcpu": "28",
        "ram": "112",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0111200MO"
    },
    {
        "name": "ECS-14vCPU-112GB-RedHat-On-Demand",
        "price": 4.18,
        "vcpu": "14",
        "ram": "112",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0111200MO"
    },
    {
        "name": "ECS-2vCPU-8GB-Linux-1Yr-UpFront",
        "price": 187.31,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100812FU"
    },
    {
        "name": "ECS-16vCPU-128GB-WIN-1Yr-UpFront",
        "price": 3348.13,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0112812FU"
    },
    {
        "name": "ECS-14vCPU-112GB-RedHat-1Yr-UpFront",
        "price": 1764.41,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0111212FU"
    },
    {
        "name": "ECS-18vCPU-144GB-RedHat-3Yrs-NoUpFront",
        "price": 1887.25,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0114436MO"
    },
    {
        "name": "ECS-28vCPU-112GB-RedHat-3Yrs-PartUpFront",
        "price": 2282.59,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0111236PU"
    },
    {
        "name": "ECS-1vCPU-2GB-RedHat-3Yrs-UpFront",
        "price": 241.3,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200236FU"
    },
    {
        "name": "ECS-6vCPU-48GB-RedHat-3Yrs-UpFront",
        "price": 606.41,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0104836FU"
    },
    {
        "name": "ECS-28vCPU-56GB-WIN-1Yr-NoUpFront",
        "price": 2600.42,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205612MO"
    },
    {
        "name": "ECS-6vCPU-48GB-Linux-1Yr-NoUpFront",
        "price": 717.97,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0104812MO"
    },
    {
        "name": "ECS-32vCPU-128GB-RedHat-1Yr-UpFront",
        "price": 3610.7,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112812FU"
    },
    {
        "name": "ECS-22vCPU-88GB-WIN-3Yrs-UpFront",
        "price": 2332.86,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108836FU"
    },
    {
        "name": "ECS-28vCPU-56GB-Linux-On-Demand",
        "price": 4.24,
        "vcpu": "28",
        "ram": "56",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205600MO"
    },
    {
        "name": "ECS-14vCPU-28GB-RedHat-On-Demand",
        "price": 2.78,
        "vcpu": "14",
        "ram": "28",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202800MO"
    },
    {
        "name": "ECS-8vCPU-32GB-RedHat-1Yr-NoUpFront",
        "price": 1109.52,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0103212MO"
    },
    {
        "name": "ECS-4vCPU-16GB-RedHat-3Yrs-PartUpFront",
        "price": 460.16,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0101636PU"
    },
    {
        "name": "ECS-2vCPU-8GB-WIN-1Yr-PartUpFront",
        "price": 283.51,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100812PU"
    },
    {
        "name": "ECS-14vCPU-56GB-WIN-3Yrs-PartUpFront",
        "price": 1515.8,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0105636PU"
    },
    {
        "name": "ECS-8vCPU-32GB-RedHat-3Yrs-UpFront",
        "price": 678.55,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0103236FU"
    },
    {
        "name": "ECS-10vCPU-20GB-Linux-3Yrs-NoUpFront",
        "price": 528.45,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202036MO"
    },
    {
        "name": "ECS-20vCPU-40GB-WIN-On-Demand",
        "price": 3.77,
        "vcpu": "20",
        "ram": "40",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204000MO"
    },
    {
        "name": "ECS-8vCPU-32GB-Linux-3Yrs-NoUpFront",
        "price": 568.62,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0103236MO"
    },
    {
        "name": "ECS-24vCPU-48GB-RedHat-1Yr-PartUpFront",
        "price": 2388.93,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204812PU"
    },
    {
        "name": "ECS-10vCPU-80GB-Linux-1Yr-UpFront",
        "price": 1115.04,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0108012FU"
    },
    {
        "name": "ECS-1vCPU-8GB-RedHat-3Yrs-NoUpFront",
        "price": 241.91,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0100836MO"
    },
    {
        "name": "ECS-14vCPU-56GB-RedHat-1Yr-UpFront",
        "price": 1588.92,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0105612FU"
    },
    {
        "name": "ECS-22vCPU-88GB-WIN-1Yr-PartUpFront",
        "price": 3118.66,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108812PU"
    },
    {
        "name": "ECS-10vCPU-40GB-Linux-On-Demand",
        "price": 2,
        "vcpu": "10",
        "ram": "40",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104000MO"
    },
    {
        "name": "ECS-32vCPU-64GB-RedHat-On-Demand",
        "price": 6.3,
        "vcpu": "32",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206400MO"
    },
    {
        "name": "ECS-14vCPU-56GB-WIN-1Yr-UpFront",
        "price": 1937.72,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0105612FU"
    },
    {
        "name": "ECS-20vCPU-80GB-WIN-1Yr-UpFront",
        "price": 2768.18,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108012FU"
    },
    {
        "name": "ECS-30vCPU-120GB-WIN-3YrsNoUpFront",
        "price": 3348.6,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112036MO"
    },
    {
        "name": "ECS-26vCPU-52GB-Linux-1Yr-UpFront",
        "price": 1822,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205212FU"
    },
    {
        "name": "ECS-20vCPU-40GB-WIN-3Yrs-UpFront",
        "price": 1257.34,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204036FU"
    },
    {
        "name": "ECS-8vCPU-16GB-RedHat-3Yrs-NoUpFront",
        "price": 650.92,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201636MO"
    },
    {
        "name": "ECS-10vCPU-80GB-RedHat-1Yr-UpFront",
        "price": 1318.4,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0108012FU"
    },
    {
        "name": "ECS-32vCPU-128GB-WIN-1Yr-PartUpFront",
        "price": 4536.24,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112812PU"
    },
    {
        "name": "ECS-22vCPU-44GB-WIN-1Yr-UpFront",
        "price": 1917.45,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204412FU"
    },
    {
        "name": "ECS-1vCPU-8GB-WIN-3Yrs-NoUpFront",
        "price": 201.58,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0100836MO"
    },
    {
        "name": "ECS-2vCPU-16GB-Linux-1Yr-UpFront",
        "price": 223.01,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0101612FU"
    },
    {
        "name": "ECS-16vCPU-32GB-RedHat-1Yr-UpFront",
        "price": 1423.79,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203212FU"
    },
    {
        "name": "ECS-12vCPU-24GB-RedHat-3Yrs-UpFront",
        "price": 740.45,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202436FU"
    },
    {
        "name": "ECS-32vCPU-128GB-Linux-3Yrs-PartUpFront",
        "price": 2113.91,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112836PU"
    },
    {
        "name": "ECS-1vCPU-4GB-RedHat-3Yrs-UpFront",
        "price": 245.4,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100436FU"
    },
    {
        "name": "ECS-18vCPU-72GB-Linux-1Yr-UpFront",
        "price": 1685.78,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0107212FU"
    },
    {
        "name": "ECS-26vCPU-52GB-WIN-3Yrs-NoUpFront",
        "price": 1708.84,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205236MO"
    },
    {
        "name": "ECS-14vCPU-56GB-WIN-On-Demand",
        "price": 3.73,
        "vcpu": "14",
        "ram": "56",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0105600MO"
    },
    {
        "name": "ECS-8vCPU-32GB-RedHat-1Yr-UpFront",
        "price": 1027,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0103212FU"
    },
    {
        "name": "ECS-12vCPU-24GB-WIN-1Yr-NoUpFront",
        "price": 1114.46,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202412MO"
    },
    {
        "name": "ECS-14vCPU-112GB-RedHat-1Yr-NoUpFront",
        "price": 1893.51,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0111212MO"
    },
    {
        "name": "ECS-16vCPU-64GB-RedHat-1Yr-NoUpFront",
        "price": 1918.96,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0106412MO"
    },
    {
        "name": "ECS-20vCPU-40GB-WIN-1Yr-PartUpFront",
        "price": 1771.71,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204012PU"
    },
    {
        "name": "ECS-8vCPU-64GB-WIN-1Yr-PartUpFront",
        "price": 1720.14,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0106412PU"
    },
    {
        "name": "ECS-12vCPU-24GB-Linux-1Yr-PartUpFront",
        "price": 854.71,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202412PU"
    },
    {
        "name": "ECS-12vCPU-48GB-Linux-1Yr-NoUpFront",
        "price": 1214.16,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104812MO"
    },
    {
        "name": "ECS-26vCPU-52GB-RedHat-3Yrs-UpFront",
        "price": 1612.74,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205236FU"
    },
    {
        "name": "ECS-1vCPU-8GB-RedHat-1Yr-NoUpFront",
        "price": 337.9,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0100812MO"
    },
    {
        "name": "ECS-12vCPU-24GB-WIN-3Yrs-PartUpFront",
        "price": 771.55,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202436PU"
    },
    {
        "name": "ECS-8vCPU-64GB-WIN-3Yrs-PartUpFront",
        "price": 1581.92,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0106436PU"
    },
    {
        "name": "ECS-6vCPU-48GB-Linux-1Yr-UpFront",
        "price": 669.02,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0104812FU"
    },
    {
        "name": "ECS-10vCPU-40GB-Linux-1Yr-UpFront",
        "price": 936.54,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104012FU"
    },
    {
        "name": "ECS-28vCPU-112GB-WIN-1Yr-NoUpFront",
        "price": 4062.97,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0111212MO"
    },
    {
        "name": "ECS-2vCPU-4GB-RedHat-3Yrs-NoUpFront",
        "price": 333.85,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200436MO"
    },
    {
        "name": "ECS-18vCPU-72GB-RedHat-3Yrs-UpFront",
        "price": 1519.34,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0107236FU"
    },
    {
        "name": "ECS-6vCPU-12GB-Linux-1Yr-UpFront",
        "price": 420.46,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201212FU"
    },
    {
        "name": "ECS-22vCPU-88GB-Linux-3Yrs-NoUpFront",
        "price": 1563.69,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108836MO"
    },
    {
        "name": "ECS-14vCPU-28GB-Linux-1Yr-NoUpFront",
        "price": 1045.41,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202812MO"
    },
    {
        "name": "ECS-6vCPU-24GB-WIN-3Yrs-PartUpFront",
        "price": 649.63,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0102436PU"
    },
    {
        "name": "ECS-28vCPU-56GB-RedHat-3Yrs-NoUpFront",
        "price": 1983.81,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205636MO"
    },
    {
        "name": "ECS-24vCPU-48GB-Linux-3Yrs-UpFront",
        "price": 1089.06,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204836FU"
    },
    {
        "name": "ECS-22vCPU-44GB-WIN-3Yrs-UpFront",
        "price": 1383.08,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204436FU"
    },
    {
        "name": "ECS-2vCPU-16GB-WIN-3Yrs-PartUpFront",
        "price": 395.48,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0101636PU"
    },
    {
        "name": "ECS-22vCPU-44GB-Linux-1Yr-PartUpFront",
        "price": 1566.96,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204412PU"
    },
    {
        "name": "ECS-4vCPU-8GB-WIN-1Yr-NoUpFront",
        "price": 371.49,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200812MO"
    },
    {
        "name": "ECS-18vCPU-144GB-Linux-On-Demand",
        "price": 4.76,
        "vcpu": "18",
        "ram": "144",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0114400MO"
    },
    {
        "name": "ECS-30vCPU-60GB-Linux-1Yr-NoUpFront",
        "price": 2240.16,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206012MO"
    },
    {
        "name": "ECS-6vCPU-48GB-RedHat-3Yrs-NoUpFront",
        "price": 670.24,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0104836MO"
    },
    {
        "name": "ECS-4vCPU-8GB-WIN-1Yr-UpFront",
        "price": 348.63,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200812FU"
    },
    {
        "name": "ECS-1vCPU-4GB-RedHat-3Yrs-PartUpFront",
        "price": 261.98,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100436PU"
    },
    {
        "name": "ECS-1vCPU-8GB-WIN-3Yrs-UpFront",
        "price": 193.9,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0100836FU"
    },
    {
        "name": "ECS-2vCPU-16GB-WIN-3Yrs-UpFront",
        "price": 387.8,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0101636FU"
    },
    {
        "name": "ECS-20vCPU-40GB-WIN-3Yrs-PartUpFront",
        "price": 1285.92,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204036PU"
    },
    {
        "name": "ECS-10vCPU-20GB-RedHat-1Yr-NoUpFront",
        "price": 1069.12,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202012MO"
    },
    {
        "name": "ECS-8vCPU-16GB-RedHat-3Yrs-UpFront",
        "price": 558.94,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201636FU"
    },
    {
        "name": "ECS-16vCPU-128GB-Linux-1Yr-UpFront",
        "price": 1784.06,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0112812FU"
    },
    {
        "name": "ECS-6vCPU-24GB-WIN-1Yr-UpFront",
        "price": 830.45,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0102412FU"
    },
    {
        "name": "ECS-2vCPU-8GB-RedHat-On-Demand",
        "price": 0.99,
        "vcpu": "2",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100800MO"
    },
    {
        "name": "ECS-14vCPU-112GB-WIN-3Yrs-UpFront",
        "price": 2714.6,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0111236FU"
    },
    {
        "name": "ECS-16vCPU-64GB-WIN-1Yr-PartUpFront",
        "price": 2268.12,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0106412PU"
    },
    {
        "name": "ECS-22vCPU-88GB-RedHat-1Yr-PartUpFront",
        "price": 2745.79,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108812PU"
    },
    {
        "name": "ECS-12vCPU-24GB-WIN-3Yrs-UpFront",
        "price": 754.41,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202436FU"
    },
    {
        "name": "ECS-2vCPU-8GB-RedHat-1Yr-UpFront",
        "price": 465.07,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100812FU"
    },
    {
        "name": "ECS-8vCPU-16GB-WIN-1Yr-PartUpFront",
        "price": 708.68,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201612PU"
    },
    {
        "name": "ECS-20vCPU-40GB-WIN-1Yr-NoUpFront",
        "price": 1857.44,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204012MO"
    },
    {
        "name": "ECS-10vCPU-40GB-WIN-3Yrs-UpFront",
        "price": 1060.39,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104036FU"
    },
    {
        "name": "ECS-24vCPU-48GB-RedHat-3Yrs-PartUpFront",
        "price": 1637.58,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204836PU"
    },
    {
        "name": "ECS-6vCPU-48GB-RedHat-3Yrs-PartUpFront",
        "price": 617.05,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0104836PU"
    },
    {
        "name": "ECS-10vCPU-80GB-Linux-3Yrs-PartUpFront",
        "price": 788.68,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0108036PU"
    },
    {
        "name": "ECS-8vCPU-64GB-Linux-On-Demand",
        "price": 2.12,
        "vcpu": "8",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0106400MO"
    },
    {
        "name": "ECS-2vCPU-4GB-WIN-On-Demand",
        "price": 0.38,
        "vcpu": "2",
        "ram": "4",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200400MO"
    },
    {
        "name": "ECS-4vCPU-32GB-WIN-3Yrs-NoUpFront",
        "price": 806.32,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0103236MO"
    },
    {
        "name": "ECS-26vCPU-52GB-Linux-3Yrs-PartUpFront",
        "price": 1269.42,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205236PU"
    },
    {
        "name": "ECS-6vCPU-24GB-WIN-3YrsNoUpFront",
        "price": 669.72,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0102436MO"
    },
    {
        "name": "ECS-4vCPU-32GB-RedHat-3Yrs-NoUpFront",
        "price": 498.91,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0103236MO"
    },
    {
        "name": "ECS-4vCPU-32GB-WIN-3Yrs-UpFront",
        "price": 775.6,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0103236FU"
    },
    {
        "name": "ECS-14vCPU-28GB-Linux-On-Demand",
        "price": 2.12,
        "vcpu": "14",
        "ram": "28",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202800MO"
    },
    {
        "name": "ECS-24vCPU-48GB-WIN-1Yr-UpFront",
        "price": 2091.76,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204812FU"
    },
    {
        "name": "ECS-10vCPU-80GB-Linux-1Yr-NoUpFront",
        "price": 1196.62,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0108012MO"
    },
    {
        "name": "ECS-16vCPU-32GB-WIN-1Yr-PartUpFront",
        "price": 1417.37,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203212PU"
    },
    {
        "name": "ECS-10vCPU-40GB-WIN-3Yrs-PartUpFront",
        "price": 1082.71,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104036PU"
    },
    {
        "name": "ECS-14vCPU-28GB-WIN-3Yrs-NoUpFront",
        "price": 920.15,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202836MO"
    },
    {
        "name": "ECS-30vCPU-120GB-Linux-1Yr-NoUpFront",
        "price": 3035.41,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112012MO"
    },
    {
        "name": "ECS-12vCPU-24GB-Linux-3Yrs-UpFront",
        "price": 544.53,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202436FU"
    },
    {
        "name": "ECS-16vCPU-64GB-RedHat-3Yrs-NoUpFront",
        "price": 1348.03,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0106436MO"
    },
    {
        "name": "ECS-26vCPU-104GB-RedHat-3Yrs-PartUpFront",
        "price": 2150.47,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0110436PU"
    },
    {
        "name": "ECS-22vCPU-88GB-Linux-1Yr-PartUpFront",
        "price": 2115.59,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108812PU"
    },
    {
        "name": "ECS-1vCPU-2GB-RedHat-3Yrs-PartUpFront",
        "price": 259.62,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200236PU"
    },
    {
        "name": "ECS-2vCPU-8GB-Linux-1Yr-PartUpFront",
        "price": 192.33,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100812PU"
    },
    {
        "name": "ECS-8vCPU-64GB-RedHat-1Yr-UpFront",
        "price": 1095.39,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0106412FU"
    },
    {
        "name": "ECS-4vCPU-16GB-WIN-3Yrs-UpFront",
        "price": 424.16,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0101636FU"
    },
    {
        "name": "ECS-10vCPU-20GB-WIN-3Yrs-UpFront",
        "price": 628.67,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202036FU"
    },
    {
        "name": "ECS-12vCPU-96GB-Linux-1Yr-NoUpFront",
        "price": 1435.95,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0109612MO"
    },
    {
        "name": "ECS-6vCPU-48GB-Linux-On-Demand",
        "price": 1.59,
        "vcpu": "6",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0104800MO"
    },
    {
        "name": "ECS-30vCPU-120GB-RedHat-On-Demand",
        "price": 7.3,
        "vcpu": "30",
        "ram": "120",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112000MO"
    },
    {
        "name": "ECS-26vCPU-104GB-WIN-1Yr-NoUpFront",
        "price": 3772.76,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0110412MO"
    },
    {
        "name": "ECS-22vCPU-44GB-Linux-1Yr-NoUpFront",
        "price": 1642.78,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204412MO"
    },
    {
        "name": "ECS-16vCPU-128GB-Linux-1Yr-PartUpFront",
        "price": 1805.81,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0112812PU"
    },
    {
        "name": "ECS-16vCPU-64GB-RedHat-3Yrs-UpFront",
        "price": 1173.58,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0106436FU"
    },
    {
        "name": "ECS-1vCPU-8GB-Linux-3Yrs-NoUpFront",
        "price": 85.67,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0100836MO"
    },
    {
        "name": "ECS-18vCPU-36GB-RedHat-1Yr-UpFront",
        "price": 1929.94,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203612FU"
    },
    {
        "name": "ECS-6vCPU-12GB-Linux-3Yrs-NoUpFront",
        "price": 317.07,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201236MO"
    },
    {
        "name": "ECS-10vCPU-80GB-WIN-3Yrs-NoUpFront",
        "price": 2015.79,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0108036MO"
    },
    {
        "name": "ECS-2vCPU-8GB-Linux-3Yrs-PartUpFront",
        "price": 132.12,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100836PU"
    },
    {
        "name": "ECS-1vCPU-8GB-Linux-3Yrs-UpFront",
        "price": 77.51,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0100836FU"
    },
    {
        "name": "ECS-2vCPU-4GB-RedHat-3Yrs-UpFront",
        "price": 286.68,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200436FU"
    },
    {
        "name": "ECS-32vCPU-64GB-WIN-On-Demand",
        "price": 6.03,
        "vcpu": "32",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206400MO"
    },
    {
        "name": "ECS-10vCPU-80GB-RedHat-3Yrs-NoUpFront",
        "price": 1012.91,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0108036MO"
    },
    {
        "name": "ECS-32vCPU-64GB-Linux-1Yr-UpFront",
        "price": 2242.46,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206412FU"
    },
    {
        "name": "ECS-14vCPU-112GB-WIN-1Yr-UpFront",
        "price": 2929.61,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0111212FU"
    },
    {
        "name": "ECS-14vCPU-56GB-WIN-1Yr-NoUpFront",
        "price": 2031.48,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0105612MO"
    },
    {
        "name": "ECS-12vCPU-48GB-Linux-3Yrs-PartUpFront",
        "price": 792.72,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104836PU"
    },
    {
        "name": "ECS-18vCPU-36GB-RedHat-3Yrs-UpFront",
        "price": 1249.72,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203636FU"
    },
    {
        "name": "ECS-4vCPU-16GB-Linux-1Yr-PartUpFront",
        "price": 384.65,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0101612PU"
    },
    {
        "name": "ECS-12vCPU-24GB-Linux-3Yrs-PartUpFront",
        "price": 585.89,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202436PU"
    },
    {
        "name": "ECS-22vCPU-44GB-WIN-On-Demand",
        "price": 4.15,
        "vcpu": "22",
        "ram": "44",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204400MO"
    },
    {
        "name": "ECS-26vCPU-104GB-WIN-3Yrs-PartUpFront",
        "price": 2815.06,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0110436PU"
    },
    {
        "name": "ECS-8vCPU-16GB-WIN-3Yrs-UpFront",
        "price": 502.94,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201636FU"
    },
    {
        "name": "ECS-10vCPU-80GB-Linux-On-Demand",
        "price": 2.64,
        "vcpu": "10",
        "ram": "80",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0108000MO"
    },
    {
        "name": "ECS-20vCPU-40GB-RedHat-3Yrs-UpFront",
        "price": 1340.47,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204036FU"
    },
    {
        "name": "ECS-20vCPU-80GB-RedHat-1Yr-PartUpFront",
        "price": 2553.46,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108012PU"
    },
    {
        "name": "ECS-10vCPU-80GB-RedHat-On-Demand",
        "price": 3.13,
        "vcpu": "10",
        "ram": "80",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0108000MO"
    },
    {
        "name": "ECS-30vCPU-120GB-RedHat-1Yr-UpFront",
        "price": 3423.39,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112012FU"
    },
    {
        "name": "ECS-10vCPU-40GB-WIN-On-Demand",
        "price": 2.67,
        "vcpu": "10",
        "ram": "40",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104000MO"
    },
    {
        "name": "ECS-8vCPU-32GB-WIN-1Yr-PartUpFront",
        "price": 1134.06,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0103212PU"
    },
    {
        "name": "ECS-26vCPU-52GB-Linux-3Yrs-UpFront",
        "price": 1179.82,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205236FU"
    },
    {
        "name": "ECS-16vCPU-64GB-RedHat-1Yr-PartUpFront",
        "price": 1823.81,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0106412PU"
    },
    {
        "name": "ECS-32vCPU-64GB-Linux-1Yr-PartUpFront",
        "price": 2279.22,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206412PU"
    },
    {
        "name": "ECS-6vCPU-12GB-RedHat-On-Demand",
        "price": 1.56,
        "vcpu": "6",
        "ram": "12",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201200MO"
    },
    {
        "name": "ECS-32vCPU-128GB-WIN-1Yr-NoUpFront",
        "price": 4643.39,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112812MO"
    },
    {
        "name": "ECS-1vCPU-4GB-Linux-3Yrs-NoUpFront",
        "price": 71.08,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100436MO"
    },
    {
        "name": "ECS-4vCPU-32GB-WIN-On-Demand",
        "price": 1.49,
        "vcpu": "4",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0103200MO"
    },
    {
        "name": "ECS-26vCPU-104GB-RedHat-1Yr-PartUpFront",
        "price": 3130.44,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0110412PU"
    },
    {
        "name": "ECS-6vCPU-12GB-RedHat-3Yrs-NoUpFront",
        "price": 545.23,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201236MO"
    },
    {
        "name": "ECS-16vCPU-128GB-RedHat-On-Demand",
        "price": 4.71,
        "vcpu": "16",
        "ram": "128",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0112800MO"
    },
    {
        "name": "ECS-10vCPU-80GB-RedHat-3Yrs-PartUpFront",
        "price": 932.52,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0108036PU"
    },
    {
        "name": "ECS-14vCPU-28GB-WIN-3Yrs-UpFront",
        "price": 880.14,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202836FU"
    },
    {
        "name": "ECS-16vCPU-32GB-WIN-3Yrs-PartUpFront",
        "price": 1028.74,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203236PU"
    },
    {
        "name": "ECS-32vCPU-64GB-Linux-On-Demand",
        "price": 4.85,
        "vcpu": "32",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206400MO"
    },
    {
        "name": "ECS-32vCPU-128GB-RedHat-1Yr-NoUpFront",
        "price": 3900.85,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112812MO"
    },
    {
        "name": "ECS-16vCPU-64GB-RedHat-1Yr-UpFront",
        "price": 1776.23,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0106412FU"
    },
    {
        "name": "ECS-30vCPU-60GB-WIN-3Yrs-PartUpFront",
        "price": 1928.88,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206036PU"
    },
    {
        "name": "ECS-14vCPU-112GB-Linux-3Yrs-PartUpFront",
        "price": 1104.16,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0111236PU"
    },
    {
        "name": "ECS-18vCPU-36GB-Linux-1Yr-PartUpFront",
        "price": 1282.06,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203612PU"
    },
    {
        "name": "ECS-4vCPU-32GB-WIN-1Yr-PartUpFront",
        "price": 860.07,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0103212PU"
    },
    {
        "name": "ECS-22vCPU-44GB-Linux-3Yrs-UpFront",
        "price": 998.31,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204436FU"
    },
    {
        "name": "ECS-14vCPU-56GB-RedHat-3Yrs-NoUpFront",
        "price": 1205.88,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0105636MO"
    },
    {
        "name": "ECS-20vCPU-40GB-Linux-1Yr-NoUpFront",
        "price": 1493.44,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204012MO"
    },
    {
        "name": "ECS-28vCPU-112GB-WIN-1Yr-UpFront",
        "price": 3875.45,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0111212FU"
    },
    {
        "name": "ECS-2vCPU-16GB-Linux-3Yrs-PartUpFront",
        "price": 157.74,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0101636PU"
    },
    {
        "name": "ECS-24vCPU-96GB-WIN-On-Demand",
        "price": 6.4,
        "vcpu": "24",
        "ram": "96",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0109600MO"
    },
    {
        "name": "ECS-12vCPU-48GB-Linux-3Yrs-NoUpFront",
        "price": 852.92,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104836MO"
    },
    {
        "name": "ECS-14vCPU-112GB-RedHat-3Yrs-NoUpFront",
        "price": 1355.58,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0111236MO"
    },
    {
        "name": "ECS-22vCPU-44GB-WIN-1Yr-NoUpFront",
        "price": 2043.18,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204412MO"
    },
    {
        "name": "ECS-6vCPU-24GB-RedHat-3Yrs-UpFront",
        "price": 554.79,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0102436FU"
    },
    {
        "name": "ECS-16vCPU-128GB-Linux-3Yrs-UpFront",
        "price": 1240.14,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0112836FU"
    },
    {
        "name": "ECS-18vCPU-36GB-Linux-1Yr-NoUpFront",
        "price": 1344.1,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203612MO"
    },
    {
        "name": "ECS-18vCPU-144GB-Linux-3Yrs-NoUpFront",
        "price": 1542.01,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0114436MO"
    },
    {
        "name": "ECS-6vCPU-12GB-Linux-On-Demand",
        "price": 0.91,
        "vcpu": "6",
        "ram": "12",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201200MO"
    },
    {
        "name": "ECS-24vCPU-48GB-RedHat-3Yrs-UpFront",
        "price": 1521.98,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204836FU"
    },
    {
        "name": "ECS-20vCPU-40GB-Linux-1Yr-UpFront",
        "price": 1401.54,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204012FU"
    },
    {
        "name": "ECS-24vCPU-96GB-RedHat-1Yr-NoUpFront",
        "price": 3091.4,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0109612MO"
    },
    {
        "name": "ECS-1vCPU-8GB-Linux-3Yrs-PartUpFront",
        "price": 78.87,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0100836PU"
    },
    {
        "name": "ECS-2vCPU-16GB-RedHat-3Yrs-PartUpFront",
        "price": 301.58,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0101636PU"
    },
    {
        "name": "ECS-12vCPU-96GB-RedHat-1Yr-PartUpFront",
        "price": 1560.2,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0109612PU"
    },
    {
        "name": "ECS-24vCPU-96GB-RedHat-3Yrs-PartUpFront",
        "price": 2018.36,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0109636PU"
    },
    {
        "name": "ECS-10vCPU-20GB-RedHat-1Yr-PartUpFront",
        "price": 1019.78,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202012PU"
    },
    {
        "name": "ECS-16vCPU-32GB-WIN-3Yrs-UpFront",
        "price": 1005.88,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203236FU"
    },
    {
        "name": "ECS-1vCPU-2GB-WIN-1Yr-PartUpFront",
        "price": 88.59,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200212PU"
    },
    {
        "name": "ECS-4vCPU-32GB-Linux-1Yr-UpFront",
        "price": 446.01,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0103212FU"
    },
    {
        "name": "ECS-12vCPU-48GB-RedHat-3Yrs-PartUpFront",
        "price": 988.64,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104836PU"
    },
    {
        "name": "ECS-2vCPU-16GB-Linux-1Yr-PartUpFront",
        "price": 225.73,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0101612PU"
    },
    {
        "name": "ECS-18vCPU-72GB-Linux-On-Demand",
        "price": 3.6,
        "vcpu": "18",
        "ram": "72",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0107200MO"
    },
    {
        "name": "ECS-8vCPU-64GB-Linux-3Yrs-UpFront",
        "price": 620.07,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0106436FU"
    },
    {
        "name": "ECS-10vCPU-20GB-RedHat-1Yr-UpFront",
        "price": 1003.33,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202012FU"
    },
    {
        "name": "ECS-32vCPU-64GB-WIN-1Yr-NoUpFront",
        "price": 2971.9,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206412MO"
    },
    {
        "name": "ECS-26vCPU-104GB-RedHat-3Yrs-UpFront",
        "price": 2014.37,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0110436FU"
    },
    {
        "name": "ECS-10vCPU-20GB-Linux-1Yr-UpFront",
        "price": 700.77,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202012FU"
    },
    {
        "name": "ECS-8vCPU-16GB-WIN-1Yr-UpFront",
        "price": 697.25,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201612FU"
    },
    {
        "name": "ECS-20vCPU-40GB-Linux-3Yrs-PartUpFront",
        "price": 976.48,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204036PU"
    },
    {
        "name": "ECS-26vCPU-104GB-WIN-3YrsNoUpFront",
        "price": 2902.12,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0110436MO"
    },
    {
        "name": "ECS-32vCPU-128GB-RedHat-3Yrs-NoUpFront",
        "price": 2740.26,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112836MO"
    },
    {
        "name": "ECS-20vCPU-40GB-Linux-On-Demand",
        "price": 3.03,
        "vcpu": "20",
        "ram": "40",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204000MO"
    },
    {
        "name": "ECS-32vCPU-128GB-WIN-3Yrs-PartUpFront",
        "price": 3464.68,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112836PU"
    },
    {
        "name": "ECS-6vCPU-24GB-Linux-1Yr-NoUpFront",
        "price": 607.08,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0102412MO"
    },
    {
        "name": "ECS-4vCPU-16GB-WIN-3Yrs-PartUpFront",
        "price": 433.09,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0101636PU"
    },
    {
        "name": "ECS-18vCPU-144GB-WIN-On-Demand",
        "price": 6.72,
        "vcpu": "18",
        "ram": "144",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0114400MO"
    },
    {
        "name": "ECS-16vCPU-32GB-WIN-1Yr-UpFront",
        "price": 1394.51,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203212FU"
    },
    {
        "name": "ECS-4vCPU-8GB-Linux-3Yrs-UpFront",
        "price": 181.51,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200836FU"
    },
    {
        "name": "ECS-4vCPU-8GB-Linux-3Yrs-PartUpFront",
        "price": 195.3,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200836PU"
    },
    {
        "name": "ECS-18vCPU-36GB-RedHat-1Yr-PartUpFront",
        "price": 1961.58,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203612PU"
    },
    {
        "name": "ECS-14vCPU-112GB-Linux-1Yr-UpFront",
        "price": 1561.05,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0111212FU"
    },
    {
        "name": "ECS-32vCPU-64GB-WIN-1Yr-PartUpFront",
        "price": 2834.74,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206412PU"
    },
    {
        "name": "ECS-6vCPU-48GB-Linux-3Yrs-UpFront",
        "price": 465.05,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0104836FU"
    },
    {
        "name": "ECS-22vCPU-88GB-WIN-On-Demand",
        "price": 5.87,
        "vcpu": "22",
        "ram": "88",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108800MO"
    },
    {
        "name": "ECS-14vCPU-28GB-WIN-1Yr-PartUpFront",
        "price": 1240.2,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202812PU"
    },
    {
        "name": "ECS-32vCPU-128GB-WIN-On-Demand",
        "price": 8.53,
        "vcpu": "32",
        "ram": "128",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112800MO"
    },
    {
        "name": "ECS-30vCPU-120GB-RedHat-1Yr-PartUpFront",
        "price": 3515.09,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112012PU"
    },
    {
        "name": "ECS-12vCPU-48GB-WIN-3Yrs-PartUpFront",
        "price": 1299.26,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104836PU"
    },
    {
        "name": "ECS-6vCPU-48GB-WIN-1Yr-PartUpFront",
        "price": 1290.11,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0104812PU"
    },
    {
        "name": "ECS-24vCPU-96GB-WIN-1Yr-NoUpFront",
        "price": 3482.54,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0109612MO"
    },
    {
        "name": "ECS-20vCPU-80GB-Linux-On-Demand",
        "price": 4,
        "vcpu": "20",
        "ram": "80",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108000MO"
    },
    {
        "name": "ECS-2vCPU-16GB-Linux-3Yrs-NoUpFront",
        "price": 171.33,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0101636MO"
    },
    {
        "name": "ECS-28vCPU-112GB-RedHat-3Yrs-NoUpFront",
        "price": 2455.96,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0111236MO"
    },
    {
        "name": "ECS-8vCPU-32GB-RedHat-On-Demand",
        "price": 2.19,
        "vcpu": "8",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0103200MO"
    },
    {
        "name": "ECS-14vCPU-112GB-WIN-3Yrs-NoUpFront",
        "price": 2822.11,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0111236MO"
    },
    {
        "name": "ECS-12vCPU-24GB-RedHat-On-Demand",
        "price": 2.47,
        "vcpu": "12",
        "ram": "24",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202400MO"
    },
    {
        "name": "ECS-26vCPU-104GB-RedHat-3Yrs-NoUpFront",
        "price": 2313.8,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0110436MO"
    },
    {
        "name": "ECS-10vCPU-40GB-RedHat-On-Demand",
        "price": 2.59,
        "vcpu": "10",
        "ram": "40",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104000MO"
    },
    {
        "name": "ECS-24vCPU-96GB-WIN-3Yrs-UpFront",
        "price": 2544.94,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0109636FU"
    },
    {
        "name": "ECS-24vCPU-96GB-Linux-On-Demand",
        "price": 4.79,
        "vcpu": "24",
        "ram": "96",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0109600MO"
    },
    {
        "name": "ECS-1vCPU-2GB-RedHat-On-Demand",
        "price": 0.81,
        "vcpu": "1",
        "ram": "2",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200200MO"
    },
    {
        "name": "ECS-10vCPU-20GB-RedHat-3Yrs-NoUpFront",
        "price": 756.61,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202036MO"
    },
    {
        "name": "ECS-32vCPU-64GB-Linux-1Yr-NoUpFront",
        "price": 2389.5,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206412MO"
    },
    {
        "name": "ECS-30vCPU-60GB-RedHat-1Yr-NoUpFront",
        "price": 2952.56,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206012MO"
    },
    {
        "name": "ECS-32vCPU-128GB-RedHat-1Yr-PartUpFront",
        "price": 3707.42,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112812PU"
    },
    {
        "name": "ECS-14vCPU-112GB-WIN-1Yr-NoUpFront",
        "price": 3090.88,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0111212MO"
    },
    {
        "name": "ECS-20vCPU-80GB-WIN-1Yr-PartUpFront",
        "price": 2835.15,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108012PU"
    },
    {
        "name": "ECS-28vCPU-112GB-WIN-1Yr-PartUpFront",
        "price": 3969.21,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0111212PU"
    },
    {
        "name": "ECS-30vCPU-120GB-WIN-On-Demand",
        "price": 8,
        "vcpu": "30",
        "ram": "120",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112000MO"
    },
    {
        "name": "ECS-16vCPU-32GB-RedHat-3Yrs-PartUpFront",
        "price": 991.98,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203236PU"
    },
    {
        "name": "ECS-28vCPU-112GB-WIN-3Yrs-UpFront",
        "price": 2969.09,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0111236FU"
    },
    {
        "name": "ECS-12vCPU-48GB-WIN-1Yr-NoUpFront",
        "price": 1741.27,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104812MO"
    },
    {
        "name": "ECS-26vCPU-52GB-WIN-1Yr-PartUpFront",
        "price": 2303.23,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205212PU"
    },
    {
        "name": "ECS-30vCPU-120GB-Linux-1Yr-UpFront",
        "price": 2809.63,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112012FU"
    },
    {
        "name": "ECS-4vCPU-32GB-RedHat-On-Demand",
        "price": 1.54,
        "vcpu": "4",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0103200MO"
    },
    {
        "name": "ECS-6vCPU-24GB-RedHat-1Yr-PartUpFront",
        "price": 862.18,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0102412PU"
    },
    {
        "name": "ECS-30vCPU-60GB-WIN-1Yr-UpFront",
        "price": 2614.7,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206012FU"
    },
    {
        "name": "ECS-6vCPU-48GB-RedHat-1Yr-PartUpFront",
        "price": 883.02,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0104812PU"
    },
    {
        "name": "ECS-16vCPU-32GB-RedHat-1Yr-NoUpFront",
        "price": 1517.15,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203212MO"
    },
    {
        "name": "ECS-24vCPU-48GB-WIN-1Yr-NoUpFront",
        "price": 2228.93,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204812MO"
    },
    {
        "name": "ECS-6vCPU-24GB-RedHat-3Yrs-NoUpFront",
        "price": 637.26,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0102436MO"
    },
    {
        "name": "ECS-14vCPU-28GB-RedHat-1Yr-PartUpFront",
        "price": 1304.68,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202812PU"
    },
    {
        "name": "ECS-12vCPU-48GB-RedHat-3Yrs-UpFront",
        "price": 926.07,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104836FU"
    },
    {
        "name": "ECS-16vCPU-128GB-RedHat-1Yr-PartUpFront",
        "price": 2011.65,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0112812PU"
    },
    {
        "name": "ECS-18vCPU-72GB-RedHat-1Yr-NoUpFront",
        "price": 2484.32,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0107212MO"
    },
    {
        "name": "ECS-12vCPU-96GB-WIN-3Yrs-PartUpFront",
        "price": 2372.87,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0109636PU"
    },
    {
        "name": "ECS-4vCPU-8GB-WIN-On-Demand",
        "price": 0.75,
        "vcpu": "4",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200800MO"
    },
    {
        "name": "ECS-14vCPU-56GB-RedHat-On-Demand",
        "price": 3.39,
        "vcpu": "14",
        "ram": "56",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0105600MO"
    },
    {
        "name": "ECS-20vCPU-40GB-Linux-1Yr-PartUpFront",
        "price": 1424.51,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204012PU"
    },
    {
        "name": "ECS-30vCPU-60GB-Linux-1Yr-UpFront",
        "price": 2102.3,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206012FU"
    },
    {
        "name": "ECS-28vCPU-112GB-RedHat-On-Demand",
        "price": 6.9,
        "vcpu": "28",
        "ram": "112",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0111200MO"
    },
    {
        "name": "ECS-4vCPU-16GB-WIN-1Yr-PartUpFront",
        "price": 567.03,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0101612PU"
    },
    {
        "name": "ECS-6vCPU-12GB-WIN-3Yrs-PartUpFront",
        "price": 385.78,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201236PU"
    },
    {
        "name": "ECS-22vCPU-44GB-Linux-On-Demand",
        "price": 3.33,
        "vcpu": "22",
        "ram": "44",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204400MO"
    },
    {
        "name": "ECS-16vCPU-32GB-RedHat-1Yr-PartUpFront",
        "price": 1447.13,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203212PU"
    },
    {
        "name": "ECS-1vCPU-2GB-Linux-1Yr-NoUpFront",
        "price": 74.67,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200212MO"
    },
    {
        "name": "ECS-2vCPU-4GB-WIN-3Yrs-PartUpFront",
        "price": 128.59,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200436PU"
    },
    {
        "name": "ECS-1vCPU-4GB-Linux-1Yr-NoUpFront",
        "price": 101.18,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100412MO"
    },
    {
        "name": "ECS-2vCPU-8GB-WIN-On-Demand",
        "price": 0.53,
        "vcpu": "2",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100800MO"
    },
    {
        "name": "ECS-30vCPU-60GB-RedHat-1Yr-UpFront",
        "price": 2770.86,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206012FU"
    },
    {
        "name": "ECS-4vCPU-16GB-Linux-3Yrs-UpFront",
        "price": 247.52,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0101636FU"
    },
    {
        "name": "ECS-12vCPU-96GB-Linux-3Yrs-UpFront",
        "price": 930.1,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0109636FU"
    },
    {
        "name": "ECS-18vCPU-36GB-Linux-3Yrs-PartUpFront",
        "price": 878.83,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203636PU"
    },
    {
        "name": "ECS-4vCPU-8GB-RedHat-1Yr-PartUpFront",
        "price": 592.42,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200812PU"
    },
    {
        "name": "ECS-16vCPU-128GB-WIN-1Yr-NoUpFront",
        "price": 3532.43,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0112812MO"
    },
    {
        "name": "ECS-4vCPU-8GB-RedHat-3Yrs-NoUpFront",
        "price": 439.54,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200836MO"
    },
    {
        "name": "ECS-4vCPU-16GB-RedHat-1Yr-NoUpFront",
        "price": 704.8,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0101612MO"
    },
    {
        "name": "ECS-1vCPU-8GB-RedHat-3Yrs-UpFront",
        "price": 218.87,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0100836FU"
    },
    {
        "name": "ECS-8vCPU-64GB-Linux-1Yr-PartUpFront",
        "price": 902.91,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0106412PU"
    },
    {
        "name": "ECS-2vCPU-16GB-RedHat-On-Demand",
        "price": 1.01,
        "vcpu": "2",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0101600MO"
    },
    {
        "name": "ECS-18vCPU-144GB-WIN-1Yr-PartUpFront",
        "price": 3870.32,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0114412PU"
    },
    {
        "name": "ECS-6vCPU-12GB-Linux-3Yrs-UpFront",
        "price": 272.27,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201236FU"
    },
    {
        "name": "ECS-10vCPU-40GB-WIN-1Yr-UpFront",
        "price": 1384.09,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104012FU"
    },
    {
        "name": "ECS-12vCPU-48GB-Linux-1Yr-PartUpFront",
        "price": 1153.96,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104812PU"
    },
    {
        "name": "ECS-1vCPU-4GB-Linux-1Yr-PartUpFront",
        "price": 96.16,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100412PU"
    },
    {
        "name": "ECS-2vCPU-16GB-WIN-3Yrs-NoUpFront",
        "price": 403.16,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0101636MO"
    },
    {
        "name": "ECS-18vCPU-144GB-Linux-1Yr-UpFront",
        "price": 2007.06,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0114412FU"
    },
    {
        "name": "ECS-28vCPU-56GB-RedHat-1Yr-NoUpFront",
        "price": 2803.22,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205612MO"
    },
    {
        "name": "ECS-16vCPU-128GB-Linux-3Yrs-NoUpFront",
        "price": 1370.68,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0112836MO"
    },
    {
        "name": "ECS-2vCPU-16GB-RedHat-1Yr-PartUpFront",
        "price": 431.57,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0101612PU"
    },
    {
        "name": "ECS-14vCPU-56GB-Linux-1Yr-UpFront",
        "price": 1311.16,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0105612FU"
    },
    {
        "name": "ECS-16vCPU-32GB-WIN-On-Demand",
        "price": 3.02,
        "vcpu": "16",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203200MO"
    },
    {
        "name": "ECS-1vCPU-8GB-WIN-3Yrs-PartUpFront",
        "price": 197.74,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0100836PU"
    },
    {
        "name": "ECS-1vCPU-2GB-Linux-3Yrs-UpFront",
        "price": 45.38,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200236FU"
    },
    {
        "name": "ECS-24vCPU-96GB-RedHat-On-Demand",
        "price": 6.1,
        "vcpu": "24",
        "ram": "96",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0109600MO"
    },
    {
        "name": "ECS-10vCPU-40GB-Linux-3Yrs-NoUpFront",
        "price": 710.77,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104036MO"
    },
    {
        "name": "ECS-6vCPU-12GB-RedHat-3Yrs-UpFront",
        "price": 468.19,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201236FU"
    },
    {
        "name": "ECS-30vCPU-120GB-Linux-1Yr-PartUpFront",
        "price": 2884.89,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112012PU"
    },
    {
        "name": "ECS-2vCPU-8GB-RedHat-3Yrs-PartUpFront",
        "price": 328.04,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100836PU"
    },
    {
        "name": "ECS-12vCPU-96GB-RedHat-3Yrs-UpFront",
        "price": 1071.46,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0109636FU"
    },
    {
        "name": "ECS-22vCPU-44GB-Linux-1Yr-UpFront",
        "price": 1541.69,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204412FU"
    },
    {
        "name": "ECS-32vCPU-64GB-RedHat-1Yr-UpFront",
        "price": 2911.02,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206412FU"
    },
    {
        "name": "ECS-8vCPU-16GB-Linux-3Yrs-UpFront",
        "price": 363.02,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201636FU"
    },
    {
        "name": "ECS-32vCPU-128GB-Linux-3Yrs-UpFront",
        "price": 1980.12,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112836FU"
    },
    {
        "name": "ECS-8vCPU-32GB-Linux-1Yr-UpFront",
        "price": 749.24,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0103212FU"
    },
    {
        "name": "ECS-30vCPU-120GB-RedHat-1Yr-NoUpFront",
        "price": 3698.49,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112012MO"
    },
    {
        "name": "ECS-26vCPU-104GB-Linux-3Yrs-UpFront",
        "price": 1608.85,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0110436FU"
    },
    {
        "name": "ECS-16vCPU-64GB-WIN-3YrsNoUpFront",
        "price": 1785.92,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0106436MO"
    },
    {
        "name": "ECS-16vCPU-64GB-Linux-1Yr-NoUpFront",
        "price": 1618.88,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0106412MO"
    },
    {
        "name": "ECS-28vCPU-56GB-RedHat-On-Demand",
        "price": 5.69,
        "vcpu": "28",
        "ram": "56",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205600MO"
    },
    {
        "name": "ECS-16vCPU-32GB-Linux-1Yr-NoUpFront",
        "price": 1194.75,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203212MO"
    },
    {
        "name": "ECS-10vCPU-80GB-RedHat-3Yrs-UpFront",
        "price": 916.45,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0108036FU"
    },
    {
        "name": "ECS-22vCPU-44GB-RedHat-3Yrs-UpFront",
        "price": 1431.23,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204436FU"
    },
    {
        "name": "ECS-2vCPU-16GB-WIN-On-Demand",
        "price": 0.75,
        "vcpu": "2",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0101600MO"
    },
    {
        "name": "ECS-6vCPU-48GB-WIN-1Yr-UpFront",
        "price": 1255.55,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0104812FU"
    },
    {
        "name": "ECS-30vCPU-60GB-WIN-3Yrs-NoUpFront",
        "price": 1971.74,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206036MO"
    },
    {
        "name": "ECS-1vCPU-8GB-Linux-On-Demand",
        "price": 0.26,
        "vcpu": "1",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0100800MO"
    },
    {
        "name": "ECS-8vCPU-16GB-Linux-3Yrs-NoUpFront",
        "price": 422.76,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201636MO"
    },
    {
        "name": "ECS-8vCPU-32GB-RedHat-3Yrs-PartUpFront",
        "price": 724.4,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0103236PU"
    },
    {
        "name": "ECS-10vCPU-40GB-WIN-1Yr-NoUpFront",
        "price": 1451.06,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104012MO"
    },
    {
        "name": "ECS-6vCPU-24GB-WIN-3Yrs-UpFront",
        "price": 636.23,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0102436FU"
    },
    {
        "name": "ECS-12vCPU-24GB-RedHat-1Yr-PartUpFront",
        "price": 1162.23,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202412PU"
    },
    {
        "name": "ECS-26vCPU-104GB-RedHat-1Yr-NoUpFront",
        "price": 3293.77,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0110412MO"
    },
    {
        "name": "ECS-12vCPU-48GB-RedHat-1Yr-PartUpFront",
        "price": 1439.16,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104812PU"
    },
    {
        "name": "ECS-12vCPU-24GB-Linux-1Yr-UpFront",
        "price": 840.92,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202412FU"
    },
    {
        "name": "ECS-8vCPU-64GB-Linux-1Yr-UpFront",
        "price": 892.03,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0106412FU"
    },
    {
        "name": "ECS-22vCPU-88GB-WIN-1Yr-UpFront",
        "price": 3044.99,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108812FU"
    },
    {
        "name": "ECS-30vCPU-120GB-RedHat-3Yrs-UpFront",
        "price": 2261.88,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112036FU"
    },
    {
        "name": "ECS-12vCPU-24GB-RedHat-1Yr-NoUpFront",
        "price": 1218.46,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202412MO"
    },
    {
        "name": "ECS-12vCPU-24GB-RedHat-3Yrs-PartUpFront",
        "price": 796.69,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202436PU"
    },
    {
        "name": "ECS-26vCPU-52GB-RedHat-3Yrs-PartUpFront",
        "price": 1735.22,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205236PU"
    },
    {
        "name": "ECS-8vCPU-64GB-Linux-3Yrs-NoUpFront",
        "price": 685.34,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0106436MO"
    },
    {
        "name": "ECS-2vCPU-4GB-RedHat-3Yrs-PartUpFront",
        "price": 308.45,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200436PU"
    },
    {
        "name": "ECS-2vCPU-16GB-WIN-1Yr-PartUpFront",
        "price": 430.04,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0101612PU"
    },
    {
        "name": "ECS-22vCPU-88GB-RedHat-3Yrs-PartUpFront",
        "price": 1886.24,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108836PU"
    },
    {
        "name": "ECS-2vCPU-16GB-RedHat-1Yr-UpFront",
        "price": 426.37,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0101612FU"
    },
    {
        "name": "ECS-10vCPU-40GB-RedHat-1Yr-UpFront",
        "price": 1214.3,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104012FU"
    },
    {
        "name": "ECS-8vCPU-16GB-RedHat-3Yrs-PartUpFront",
        "price": 601.39,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201636PU"
    },
    {
        "name": "ECS-32vCPU-64GB-WIN-3Yrs-NoUpFront",
        "price": 2103.19,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206436MO"
    },
    {
        "name": "ECS-24vCPU-48GB-Linux-On-Demand",
        "price": 3.64,
        "vcpu": "24",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204800MO"
    },
    {
        "name": "ECS-16vCPU-64GB-WIN-1Yr-UpFront",
        "price": 2214.54,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0106412FU"
    },
    {
        "name": "ECS-22vCPU-88GB-WIN-3YrsNoUpFront",
        "price": 2455.64,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108836MO"
    },
    {
        "name": "ECS-30vCPU-120GB-Linux-3Yrs-PartUpFront",
        "price": 1981.79,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112036PU"
    },
    {
        "name": "ECS-30vCPU-60GB-WIN-On-Demand",
        "price": 5.66,
        "vcpu": "30",
        "ram": "60",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206000MO"
    },
    {
        "name": "ECS-18vCPU-72GB-Linux-3Yrs-UpFront",
        "price": 1113.82,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0107236FU"
    }
]

pricing.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));

export default pricing;